import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import {SettingsService} from 'src/app/services/settings.service'
import { Router ,ActivatedRoute} from '@angular/router';
import { PageEvent } from '@angular/material/paginator';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl } from '@angular/forms'
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import { Subscription } from 'rxjs';
import {ReportingConfigService} from 'src/app/services/reporting-config.service'
import { City, Country, State, StaticdataService } from 'src/app/services/staticdata.service';
import { DataService } from 'src/app/services/data.service';
import { FlightService } from 'src/app/services/flight.service';
import {CarrierCodeService} from '../../services/carrier-code.service';
import {CartService} from '../../services/cart.service';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-modify-cart',
  templateUrl: './modify-cart.component.html',
  styleUrls: ['./modify-cart.component.css']
})
export class ModifyCartComponent {
 // showCartInformation:boolean=false
  // showItinerary:boolean=false
  // showClientInformation:boolean=false
  
  numbers: number[] = Array.from({ length: 25 }, (_, i) => i + 1);
  // Default:any
  //
  // showDataEntity:boolean=false;
  // search:any={searchText:""}
  // showDataEntityPopup:boolean=false
  // DataEntityRegFg!:FormGroup
  // columnsDataEntityDisplay: string[] = ['expand','Name','isEnabled'];
  // expandedElement!: any | null;
  // totalElements:any=0
  // action:any
  // entityList:any;
  // DataEntity:any=[]
  // creationDate:any
  // id:any
  showGSTPopup:boolean=false
  airData:any
  flightList:any
  carrierCode:any=[]
  
returnLastFlight:any
thirdLastFlight:any
fourthLastFlight:any
lastflight:any
clientName:any
bookedBy:any
cartUuid:any
comment:any

amendCartList:any=[]
showAmendProcess:any=false
userType:any
loginUserType:any
  constructor(private sanitizer: DomSanitizer,private userInfoService:UserInfoService,private SettingsService:SettingsService,private CarrierCodeService:CarrierCodeService,private router:Router,private location:Location,private fb : FormBuilder, private  toastMsgService : ToastmsgService,
    private DataEntityService:ReportingConfigService,private FlightService:FlightService,private DialogService:DialogService,
    private StaticdataService:StaticdataService,private route:ActivatedRoute,private DataService:DataService,private CartService:CartService,private UserService:UserService){

      this.userType=userInfoService.getUserType();
    this.userType=this.userType.toUpperCase()
    this.loginUserType=sessionStorage.getItem('loginUserType')
    this.loginUserType=this.loginUserType.toUpperCase()
      this.getFlightList();
      this.carrierCode=this.CarrierCodeService.carrierCode()
     
      this.dataFields()

      this.route.queryParams.subscribe(params => {
        let data:any
        data=params
      if(data?.id){
        this.cartUuid=data?.id
        if( this.cartUuid){
        this.firstCallOrder(data?.id)}
        this.GetAmend(data?.id)
        this.getSancharWhatsApp(data?.id)
        this.getSancharEmailApp(data?.id)

      }})
      this.DataService.portMessage.subscribe((message:any) =>{


       
      
      })


    }
   
    openManualBooking(orderNumber: string) {
      sessionStorage.setItem('CorpUuid',this.airData.corporate)
      const url = "/app/manual-booking?id=" + this.SettingsService.transform(orderNumber);
      window.open(url, "_blank"); // Opens in a new tab
    }
    nextPage(event:PageEvent) {
    
      let page:any = {};
      page['page'] = event.pageIndex.toString();
      page['size'] = event.pageSize.toString();
      
      //this.getAllUser(page)
    
    }
    GstRegFg!:FormGroup
  dataFields(){
    this.GstRegFg=this.fb.group({
      'name':[''],
        // "address":[''],
        // "phone":[''],
        // "email":['',[Validators.email]],
        // "state":[''],
        // "gstType":[''],
        // "gstName":[''],
        // "entityGST":[''],
        // "gstAccountCode":[''],
        // "entityName":['',[Validators.required]],
        // "accountCode":['',[Validators.required]],
        // "isEnabled":['']
        
    });
    
  }
  closePopup() {

     this.showRescheduleAmend=false
    this.showAmendProcess=false
    this.showAmendRescheduleProcess=false
    this.showActionTabs=false
    
    this.showAmendProcess=false
    this.showGSTPopup=false
    this.showAmend=false
      this.cancellationMode=''
  this.manualCancel=false
  this.passengerUpdatedArray=[]
    this.dataFields()
  this.getOrder(this.cartUuid)

  }
  openGstDetail(){
    this.showGSTPopup=true

  }
  AddDataEntity(){
    

    //   this.DataEntityService.saveEntity(this.DataEntityRegFg.value,this.id)
    //   .subscribe({
    //     next : (res) => {
    //       if(res.status==200 || res.status==201) {
    //         this.toastMsgService.setMsg({msg : "Billing Entity Added Successfully!",msgTitle : "Success", msgType : "I"});
           
    //        this.showDataEntityPopup=false
    //        this.dataFields();
    //        this.dataEntitylist()

    //       } else {
    //         const body : any = res.body;
    //         this.registerDataEntityErrorMsg(res.status,body?.result);
    //       } 
  
    //     },error : (err) => {
  
    //       this.registerDataEntityErrorMsg(err.status,err.error);
    //     }
    //   }
    // )
  }
  
  registerDataEntityErrorMsg(status : number,msg : string) {
    if(status >=500) {
      this.toastMsgService.setMsg({msg : "Failed to save Billing Entity",msgTitle : "Warning", msgType : "W"});
    } else {
  
      this.toastMsgService.setMsg({msg : "Failed to save Billing Entity",msgTitle:  "Warning", msgType : "W"});
    } 
  }
  
  
  backClick(){
    window.close();

    // window.location.href = "/app/manage-carts"
    }
      rowdataEntityClick(element:any){
       
        // this.action="updateEntity"
        // this.showDataEntityPopup=true
        // this.DataEntityRegFg=this.fb.group({
        //   "address":[element?.address],
        //   "phone":[element?.phone],
        //   "email":[element?.email,[Validators.email]],
        //   "state":[element?.state],
        //   "gstType":[element?.gstType],
        //   "gstName":[element?.gstName],
        //   "entityGST":[element?.entityGST],
        //   "gstAccountCode":[element?.gstAccountCode],
        //   "entityName":[element?.entityName,[Validators.required]],
        //   "accountCode":[element?.accountCode,[Validators.required]],
        //   "isEnabled":[element?.isEnabled.toString()],
        //   "entityId":[element?.entityId]
        // });
       
      }
      formatDate(val: Date) {
        let convertedValue:any = ""
        if(val){
        let datepipe = new DatePipe("en");
        //return datepipe.transform(val, "dd-MM-yyyy hh:mm:ss");
        convertedValue =  datepipe.transform(val, "dd-MM-yyyy hh:mm:ssa");
        }
        return convertedValue;
      }
     
     
     
      stateData:any
stateList(){
  this.StaticdataService
  .getStates()
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.stateData=data
    //  console.log(this.stateData)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

getFlightList(){
   
  this.FlightService
  .getFlightList()
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
       this.flightList=data
   
      } else {    
      } 
    },error : (err) => {

      
    }
  }
)
}
converter(item:any){
  const totalMinutes = item ;
  const hours = Math.floor(totalMinutes / 60);
  const remainingMinutes = totalMinutes % 60;
  item=`${hours}h ${remainingMinutes}m`
  return item
}
fligthNameFilter(item:any){
if(item){
let flightName:any=[]
flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
if(flightName.length===0){
 return item

}else{
 flightName =flightName[0].flightName
 return flightName
}}else{
return item
}
}
cityFilter(item:any){
  

  if(item && this.flightList){
   

    item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

  item=item[0]?.city

return item}else{
  return item
}
}
airPortFilter(item:any){
  
  if(item && this.flightList){
  item=this.flightList.filter((itm: { iataCode: any; })=>itm.iataCode === item)

item=item[0]?.name
return item}else{
  return item
}
}
timeFormate(date:any){
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'hh:mma');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');

return date

}
convertToISOStringFormat(dateString:any) {
  // Remove the ' 00:00' part and then add 'Z' at the end
  const isoDateString = dateString?.replace('00.000 00:00', '00.000Z');
  return isoDateString;
}
flightlogoFilter(item:any){
  
  if(item){
     let flightName:any=[]
  flightName=this.carrierCode.filter((itm: { carrierCode: any; })=>itm.carrierCode === item)
  
  if(flightName.length===0){
   return item
 
 }else{
   flightName =flightName[0]?.logo
   return flightName
 }
  }else{return item}
 }
 dateFormate(date:any){

  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}
scroll(el: HTMLElement) {
  el.scrollIntoView();
}




salesDetail(invoice:any,i:any){
  this.airData.invoiceData[i].boolean=true
  let request:any={
    itineraryId:invoice?.itineraryId,
    invoiceId:invoice?.id,
    docPref:invoice?.docPref,
    orderId:this.airData?.uuid,
    transactionType:invoice?.transactionType ,
  }
  this.CartService
  .saledetails(request)
  .subscribe({
    next : (res:any) => {
      this.airData.invoiceData[i].boolean=false

      this.toastMsgService.setMsg({msg : "Success!",msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      if(res) {
     let data=res
     
      } else {
      
      } 
    },error : (err) => {
      this.airData.invoiceData[i].boolean=false

      this.toastMsgService.setMsg({msg : "Failed",msgTitle : "Warning", msgType : "W"});

    }
  }
)
}
whatsApp(number:any){
  this.DialogService.open({msg : 'Send WhatsApp to this Number: '+number,title : "Confirmation",buttonType : "send"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Send") {
      let request:any={}
      if(this.WhatsAppNumber===null){
        request=null
      }else{
        request={'whatsappNumber':number}
       }
  this.CartService
  .whatsApp(this.airData?.uuid,request)
  .subscribe({
    next : (res:any) => {
      
      this.WhatsAppNumber=null

      if(res) {
        let data:any
         data=res
if(data.WA===true){
  this.getSancharWhatsApp(this.cartUuid)
        this.toastMsgService.setMsg({msg : "Send WhatsApp Successfully!",msgTitle : "Success", msgType : "I"});
      }else{

        this.toastMsgService.setMsg({msg : "Failed to Send WhatsApp!",msgTitle : "Warning", msgType : "W"});

      }

     
      } else {
        this.toastMsgService.setMsg({msg : "Failed to Send WhatsApp!",msgTitle : "Warning", msgType : "W"});

      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : "Failed to Send WhatsApp!",msgTitle : "Warning", msgType : "W"});
      this.WhatsAppNumber=null
    }
  }
)}else if(response==='Change Number'){
  this.showNewWhatsApp=true

}else if(response==='Cancel'){
  this.showNewWhatsApp=false
  this.WhatsAppNumber=null
}


})
}



getBookedByUUid(id:any){

  this.UserService.getUserbyUUid(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     this.bookedBy= res?.name

      } else {
      } 
    },error : (err) => {

    }
  }
)


}


getUserByUUid(id:any){
 
  this.UserService.getUserbyUUid(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     this.clientName= res?.name

      } else {
      } 
    },error : (err) => {

    }
  }
)


}



WhatsAppNumber:any=null
showNewWhatsApp:boolean=false
SendNewNo(input:any) {
  this.showNewWhatsApp=false

  this.whatsApp(input)
}


onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}
isInputValid: boolean = false;
validateInput(){
  if (this.WhatsAppNumber.length === 10) {
    this.isInputValid = true;
  } else {
    this.isInputValid = false;
  }
}

downloadInvoiceLog(element:any){
  if(element?.invoiceLog===null){
    element.invoiceLog=''
  }
  this.downloadTextFile(element?.invoiceLog, element?.uniqueId+'.txt');
}
downloadTextFile(data: any, filename: string) {
  const blob = new Blob([JSON.stringify(data)], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);

  const anchor = document.createElement('a');
  anchor.download = filename;
  anchor.href = url;
  anchor.click();

  window.URL.revokeObjectURL(url);
}

refresh(){
  this.getOrder(this.cartUuid)
}
firstCallOrder(uuid:any){
  this.showCartData=true
  this.getOrder(uuid)
}
travellerDetail:any
showCartData:boolean=false
// fare:any={
//   totalPrice:0,
//   totalTax:0
// }
flightData:any
flightArray:any=[]
 getOrder(uuid:any){
  this.CartService.getOrder(uuid)
  .subscribe({
    next : (res:any) => {
      this.showCartData=false

      if(res) {
     let data:any
     data=res
     this.airData = data
     let filterData:any=this.checkResch( JSON.parse(JSON.stringify(data)))
     this.rescheduleAirData=filterData
this.flightData={...data}

     this.travellerDetail=this.airData.travellerDetail
     this.flightArray=[]
    
for(let flight of this.flightData.airItineraries)  {
  if(flight.status==='B'){
    this.flightArray.push(flight)

  }
// this.fare.totalPrice +=flight.fare[0].baseFare
// this.fare.totalTax +=flight.fare[0].finalTax
}

this.initializeAdvancedPricingDataList()

     this.dataEntitylist()
     this.getUserByUUid(this.airData?.corporate)
     this.getBookedByUUid( this.airData?.createdBy)


      
     

      if(this.airData && this.airData.airItineraries.length!=0){
        

      const returnItem=this.airData?.airItineraries[1];
      const thirdItem=this.airData?.airItineraries[2];
  const fourthItem=this.airData?.airItineraries[3];
      // console.log(returnItem)
    
      
      
      const item = this.airData?.airItineraries[0];
    //console.log(item)
    
  
    }




      } else {
      } 
    },error : (err) => {
      this.showCartData=false


    }})
  }
  initializeAdvancedPricingDataList() {

    this.flightArray.forEach((flightsItem:any) => {
      this.advancedPricingDataList.push({
        fromAirport: flightsItem.flightDetails.flightDetailsList[0].fromAirport,
        toAirport: flightsItem.flightDetails.flightDetailsList[flightsItem?.flightDetails?.flightDetailsList.length - 1].toAirport,
        agentTicketMarkUpData: []
      });
    });
    console.log(this.advancedPricingDataList)
  }


  DataEntity:any=[]
  billingEntity:any
  dataEntitylist(){
    this.DataEntityService
   .listEntities(this.airData?.corporate)
   .subscribe({
      next : (res:any) => {
        if(res) {
       let data=res
       this.DataEntity=data
       let entity:any=[]
       if(this.airData?.billingEntity){
       entity=this.DataEntity.filter((item:any)=>item.entityRefId===this.airData?.billingEntity)
       this.billingEntity=entity[0]?.entityName
      }
        } else {
       
        } 
      },error : (err) => {

    }
    }
  )
 }


 emailId:any=null
 showNewEmail:boolean=false
 SendEmailNewNo(input:any) {
   this.showNewEmail=false
 
   this.emailSend(input)
 }


 emailSend(number:any){
  this.DialogService.open({msg : 'Send Email to this Email Id: '+number,title : "Confirmation",buttonType : "sendEmail"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Send") {
      let request:any={}
      if(this.emailId===null){
        request=null
      }else{
        request={'email':number}
       }
  this.CartService
  .emailSend(this.airData?.uuid,request)
  .subscribe({
    next : (res:any) => {
      
      this.emailId=null

      if(res) {
        let data:any
         data=res
if(data.Email===true){
  this.getSancharEmailApp(this.cartUuid)

        this.toastMsgService.setMsg({msg : "Send Email Successfully!",msgTitle : "Success", msgType : "I"});
      }else{

        this.toastMsgService.setMsg({msg : "Failed to Send Email!",msgTitle : "Warning", msgType : "W"});

      }

     
      } else {
        this.toastMsgService.setMsg({msg : "Failed to Send Email!",msgTitle : "Warning", msgType : "W"});

      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : "Failed to Send Email!",msgTitle : "Warning", msgType : "W"});
      this.emailId=null
    }
  }
)}else if(response==='Change Email Id'){
  this.showNewEmail=true

}else if(response==='Cancel'){
 
  this.emailId=null
 this.showNewEmail=false
}


})
}
closedPopup() {
  this.showNewWhatsApp=false
  this.WhatsAppNumber=null

  this.emailId=null
 this.showNewEmail=false
  }
  isEmailValid: boolean = false;


validateEmailInput(email: string): boolean {
  // Regular expression for email validation
  const emailRegex: RegExp = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
showAmend:boolean=false
amendSelect:any
amendRSelect:any
amendmentType:any
sector:any
sectorlastflight:any
pnr:any
cpnr:any
PassengerArray:any=[]

OpenAmend(type:any,item:any,lastSector:any,pnr:any,pnrdata:any,pnrObject:any){
  // console.log(pnrObject)
   this.PassengerArray=pnrObject
  //  console.log(this.PassengerArray)
  this.cpnr=pnrdata.join()
  this.pnr=pnr
    this.cancelmsg=''
  this.comment=''
  this.showAmend=true
  this.amendmentType=type
  this.sector=item

  this.sectorlastflight=lastSector
  this.manualCancellation=false
this.manualreschedule='M'
  this.cancellationMode=''
  this.manualCancel=false
  this.passengerUpdatedArray=[]

}
showRAction:boolean=false
showAction:boolean=false
showTAction:boolean=false
showFAction:boolean=false
selectedPnr:any=[]
selectedRPnr:any=[]
selectedTPnr:any=[]
selectedFPnr:any=[]
PassengerRObject:any=[]
PassengerTObject:any=[]
PassengerFObject:any=[]
PassengerObject:any=[]

itinerarySelect(element:any,flights:any){
  this.selectedPnr=[]
  this.PassengerObject=flights?.orderPassengerDetails.filter((item:any) => item.showAction === true)
  flights?.orderPassengerDetails.filter((item:any) =>{
    if(item.showAction === true){
      this.selectedPnr.push(item.pnr)
    }
        })
 if (element.showAction === true) {
    flights.showAction = true;
  } else {
    const anySelected = flights?.orderPassengerDetails.some((item: any) => item.showAction === true);
    flights.showAction = anySelected;
  }



 
}







AmendProcessDetail:any
amendAirItineraries:any
lastAmend:any
PassengerDetail:any
currentTotalVaue:any=0
amendSource:any=''
viewEdit:boolean=false
onClickAmendPro(ite:any,viewEdit:any){
  this.viewEdit = viewEdit === 'view' ? true : false;
  this.AmendProcessDetail=ite
// console.log(this.AmendProcessDetail)
if(ite.type==='Reschedule'){
  this.amendAirItineraries=this.airData.airItineraries.filter((item:any)=>item.uuid.includes( this.AmendProcessDetail?.rescheduledItineraryUuid))

  this.amendAirItineraries=this.amendAirItineraries[0]
  console.log(this.amendAirItineraries)
if(this.amendAirItineraries){
  this.amendSource=this.amendAirItineraries.flightDetails.source||''
}
  // console.log(this.amendAirItineraries.flightDetails.flightDetailsList)
  // console.log(this.amendAirItineraries.orderPassengerDetails)
  // console.log(this.AmendProcessDetail?.rescheduledItineraryUuid)
  this.PassengerDetail=this.amendAirItineraries.orderPassengerDetails.filter((item:any)=>item.itineraryUuid===this.AmendProcessDetail?.rescheduledItineraryUuid)



  this.PassengerDetail.ticketNumber=null
  this.PassengerDetail.feeMarkup=ite?.amendmentCharges?.rescheduledFees||0
  this.PassengerDetail.feeRules=ite?.amendmentCharges?.supplierAmdFees||0
 for(let PassengerDetailItem of this.PassengerDetail){
  PassengerDetailItem.feeMarkup=PassengerDetailItem?.rescheduleComponent?.rescheduledFees
  PassengerDetailItem.feeRules=PassengerDetailItem?.rescheduleComponent?.supplierAmendment

  
 }
}else {
  this.amendAirItineraries=this.airData.airItineraries.filter((item:any)=>item.pnr.includes( this.AmendProcessDetail?.refId))

  this.amendAirItineraries=this.amendAirItineraries[0]

  // this.PassengerDetail=this.amendAirItineraries.orderPassengerDetails.filter((item:any)=>item.pnr===this.AmendProcessDetail?.refId)
  
  this.PassengerDetail=this.AmendProcessDetail?.passengerList
  this.PassengerDetail.ticketNumber=null
  this.PassengerDetail.feeMarkup=ite?.amendmentCharges?.cancellationFees||0
  this.PassengerDetail.feeRules=ite?.amendmentCharges?.supplierAmdFees||0
 for(let PassengerDetailItem of this.PassengerDetail){
  PassengerDetailItem.feeMarkup=PassengerDetailItem?.amendmentCharges?.cancellationFees
  PassengerDetailItem.feeRules=PassengerDetailItem?.amendmentCharges?.supplierAmdFees

  
 }
}
  // console.log(this.PassengerDetail)
  // this.PassengerDetail=this.PassengerDetail[0]
 
// console.log(this.PassengerDetail)
  this.lastAmend=this.amendAirItineraries?.flightDetails?.flightDetailsList[this.amendAirItineraries?.flightDetails?.flightDetailsList.length - 1]
  // if(this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes.length>0){
  //   this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes=this.arrayToObject(this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes)
  // }
  this.showAmendProcess=true
  // this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes=this.objectToArray(this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes)
  // this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.totaltaxes=0

  // for(let tax of this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes){
  //   this.updateTaxValue(tax)
  // }
  let currentTotal:any=0
  // console.log(this.PassengerDetail)
// for( let p = 0; p < this.PassengerDetail.length; p++){

//   this.PassengerDetail[p].flightDetailsList= this.amendAirItineraries.repriceData.flightDetailsList
//   for (let i = 0; i < this.PassengerDetail[p].flightDetailsList.length; i++) {
//     let flight = this.PassengerDetail[p].flightDetailsList[i];

//     let PassengersArray = [this.PassengerDetail[p]]; // Convert object to array

//     // Clone the passenger details to prevent reference issues
//     flight.PassengerDetail = PassengersArray.map((passenger:any) => {
//       console.log(passenger)
//       let matchedBookingClasses = passenger.fareDetails.passengerBookingClasses.filter((item: any) =>
//         item.fareDetailsPerPassengerType.baseFare === flight.bookingClasses[0].fareDetailsPerPassengerType.baseFare &&
//         item.fareDetailsPerPassengerType.finalTax === flight.bookingClasses[0].fareDetailsPerPassengerType.finalTax &&
//         item.bookingClass === flight.bookingClasses[0].bookingClass
//       );

  
//       // Return a new object with updated fare details to avoid modifying original reference
//       return {
//         ...passenger,
//         fareDetails: {
//           ...passenger.fareDetails,
//           passengerBookingClasses: matchedBookingClasses
//         }
//       };
//     });
//   }
// }
for (let p = 0; p < this.PassengerDetail.length; p++) {
  // Ensure flightDetailsList exists before assignment
    if(ite.type==='Reschedule'){
  
  this.PassengerDetail[p].flightDetailsList = this.amendAirItineraries?.rescheduleFlightData?.flightDetailsList || [];}
else{
    this.PassengerDetail[p].flightDetailsList = this.amendAirItineraries?.repriceData?.flightDetailsList || [];

}

  for (let i = 0; i < this.PassengerDetail[p].flightDetailsList.length; i++) {
    let flight = this.PassengerDetail[p].flightDetailsList[i];

    // Prevent potential undefined errors
    if (!flight.bookingClasses || flight.bookingClasses.length === 0) {
      console.warn("Missing bookingClasses data for flight:", flight);
      continue; // Skip this iteration if bookingClasses is undefined or empty
    }

    // Clone passenger object to avoid circular references
    let clonedPassenger = JSON.parse(JSON.stringify(this.PassengerDetail[p]));

    // Update flight.PassengerDetail with filtered fare details
    flight.PassengerDetail = [
      {
        ...clonedPassenger,
        fareDetails: {
          ...clonedPassenger.fareDetails,
          passengerBookingClasses: clonedPassenger.fareDetails.passengerBookingClasses.filter((item: any) =>
            item.fareDetailsPerPassengerType.baseFare === flight.bookingClasses[0]?.fareDetailsPerPassengerType?.baseFare &&
            item.fareDetailsPerPassengerType.finalTax === flight.bookingClasses[0]?.fareDetailsPerPassengerType?.finalTax &&
            item.bookingClass === flight.bookingClasses[0]?.bookingClass
          )
        }
      }
    ];
  }
  console.log(this.PassengerDetail)

}
for(let Passengers of this.PassengerDetail){

  for(let item of Passengers.flightDetailsList ){
   item.totaltaxes=0
   item.currentValue=JSON.parse(JSON.stringify(item))
    item.classes=JSON.parse(JSON.stringify(item.PassengerDetail))

    item.classes.forEach((clas:any)=>{
      clas.currentValue=JSON.parse(JSON.stringify(clas))
      if('passengerBookingClasses' in clas.fareDetails){
      clas?.fareDetails?.passengerBookingClasses.forEach((fareDetails:any)=>{
      fareDetails.currentValue=JSON.parse(JSON.stringify(fareDetails))
        fareDetails.fareDetailsPerPassengerType.taxes=this.objectToArray(fareDetails.fareDetailsPerPassengerType.taxes)
        for(let items of fareDetails.fareDetailsPerPassengerType.taxes ){
          this.updateTaxValue(items,fareDetails)
    
        }
        currentTotal+=Number(fareDetails.fareDetailsPerPassengerType?.finalTax?(fareDetails?.fareDetailsPerPassengerType?.finalTax):0)+Number(fareDetails.fareDetailsPerPassengerType?.baseFare?(fareDetails?.fareDetailsPerPassengerType?.baseFare):0)

      })}
    })






    // for(let items of item.classes.fareDetailsPerPassengerType.taxes ){
    //   this.updateTaxValue(items,item)

    // }

    // currentTotal+=Number(item?.currentValue?.bookingClasses[0]?.fareDetailsPerPassengerType?.finalTax?(item?.currentValue?.bookingClasses[0]?.fareDetailsPerPassengerType?.finalTax):0)+Number(item?.currentValue?.bookingClasses[0]?.fareDetailsPerPassengerType?.baseFare?(item?.currentValue?.bookingClasses[0]?.fareDetailsPerPassengerType?.baseFare):0)

  }}
  // console.log(this.amendAirItineraries.repriceData.flightDetailsList)
this.currentTotalVaue=currentTotal||0
  this.ChangeTotalTax()
   

}
onOldClickAmendPro(ite:any){
  
  this.AmendProcessDetail=ite
// console.log(this.AmendProcessDetail)
if(ite.type==='Reschedule'){
  this.amendAirItineraries=this.airData.airItineraries.filter((item:any)=>item.uuid.includes( this.AmendProcessDetail?.rescheduledItineraryUuid))

  this.amendAirItineraries=this.amendAirItineraries[0]
  // console.log(this.amendAirItineraries)

  // console.log(this.amendAirItineraries.flightDetails.flightDetailsList)
  // console.log(this.amendAirItineraries.orderPassengerDetails)
  // console.log(this.AmendProcessDetail?.rescheduledItineraryUuid)
  this.PassengerDetail=this.amendAirItineraries.orderPassengerDetails.filter((item:any)=>item.itineraryUuid===this.AmendProcessDetail?.rescheduledItineraryUuid)
}else {
  this.amendAirItineraries=this.airData.airItineraries.filter((item:any)=>item.pnr.includes( this.AmendProcessDetail?.refId))

  this.amendAirItineraries=this.amendAirItineraries[0]

  this.PassengerDetail=this.amendAirItineraries.orderPassengerDetails.filter((item:any)=>item.pnr===this.AmendProcessDetail?.refId)
}
  // console.log(this.PassengerDetail)
  // this.PassengerDetail=this.PassengerDetail[0]
  this.PassengerDetail.ticketNumber=null
  this.PassengerDetail.feeRules=0
  this.PassengerDetail.feeMarkup=0
  this.PassengerDetail.feeRules=ite?.amendmentCharges?.cancellationFees||0
// console.log(this.PassengerDetail)
  this.lastAmend=this.amendAirItineraries?.flightDetails?.flightDetailsList[this.amendAirItineraries?.flightDetails?.flightDetailsList.length - 1]
  // if(this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes.length>0){
  //   this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes=this.arrayToObject(this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes)
  // }
  this.showAmendProcess=true
  // this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes=this.objectToArray(this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes)
  // this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.totaltaxes=0

  // for(let tax of this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes){
  //   this.updateTaxValue(tax)
  // }
  let currentTotal:any=0
  for(let i=0; i<this.amendAirItineraries.repriceData.flightDetailsList.length;i++){
    this.amendAirItineraries.repriceData.flightDetailsList[i].PassengerDetail=this.PassengerDetail

  }
  for(let item of this.amendAirItineraries.repriceData.flightDetailsList ){
   item.totaltaxes=0
   item.currentValue=JSON.parse(JSON.stringify(item))
    item.classes=JSON.parse(JSON.stringify(item.PassengerDetail))
    // console.log(item.classes.fareDetailsPerPassengerType.taxes)
    item.classes.forEach((clas:any)=>{
      clas.currentValue=JSON.parse(JSON.stringify(clas))
      clas.fareDetails.passengerBookingClasses.forEach((fareDetails:any)=>{
      fareDetails.currentValue=JSON.parse(JSON.stringify(fareDetails))
        fareDetails.fareDetailsPerPassengerType.taxes=this.objectToArray(fareDetails.fareDetailsPerPassengerType.taxes)
        for(let items of fareDetails.fareDetailsPerPassengerType.taxes ){
          this.updateTaxValue(items,fareDetails)
    
        }
        currentTotal+=Number(fareDetails.fareDetailsPerPassengerType?.finalTax?(fareDetails?.fareDetailsPerPassengerType?.finalTax):0)+Number(fareDetails.fareDetailsPerPassengerType?.baseFare?(fareDetails?.fareDetailsPerPassengerType?.baseFare):0)

      })
    })
    // console.log(item.classes.fareDetailsPerPassengerType.taxes)

    // for(let items of item.classes.fareDetailsPerPassengerType.taxes ){
    //   this.updateTaxValue(items,item)

    // }

    // currentTotal+=Number(item?.currentValue?.bookingClasses[0]?.fareDetailsPerPassengerType?.finalTax?(item?.currentValue?.bookingClasses[0]?.fareDetailsPerPassengerType?.finalTax):0)+Number(item?.currentValue?.bookingClasses[0]?.fareDetailsPerPassengerType?.baseFare?(item?.currentValue?.bookingClasses[0]?.fareDetailsPerPassengerType?.baseFare):0)

  }
this.currentTotalVaue=currentTotal||0
  this.ChangeTotalTax()
   

}


confirmDisabled:boolean=false
manualCancellation:boolean=false
manualreschedule:any='M'
passengerUpdatedArray:any=[]
manualCancel:boolean=false
cancellationMode:any
cancelmsg:any=''
cancel(){
  this.cancellationMode=''
  this.confirmDisabled=true
  
  this.CartService
  .cancelOrder({pnr:this.cpnr,passengerDetails:this.PassengerArray,itineraryId:this.PassengerArray[0]?.itineraryUuid,comment:this.comment},this.airData?.uuid)
  .subscribe({
    next : (res:any) => {
      this.confirmDisabled=false

      if(res){
       if( res.resStatus==='OK')
{     if(res.result&&res.result[0].errorDetails){

          if(res.result[0].errorDetails.errorData.errorMessage){
            this.toastMsgService.setMsg({msg :res.result[0].errorDetails.errorData.errorMessage,msgTitle : "Cancellation Failed", msgType : "E"});

          }else{
            this.confirmDisabled=false
            this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});
          }

        }else{
      this.cpnr=null
     this.PassengerArray=[]
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg :'Success',msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)
      this.showAction=false

      this.showAmend=false
        }}else if(res.resStatus==='PARTIAL_CONTENT'){
          this.cancellationMode='P'
this.passengerUpdatedArray=res.result[0].passengerDetails
this.manualCancel=true
this.cancelmsg=res.message
this.toastMsgService.setMsg({msg :res.message,msgTitle : "Success", msgType : "I"});


        }else if(res.resStatus==='PROCESSING'){
          this.cancellationMode='C'
          this.cancelmsg=res.message

          this.passengerUpdatedArray=res.result[0].passengerDetails

          this.manualCancel=true

          
          this.toastMsgService.setMsg({msg :res.message,msgTitle : "Success", msgType : "I"});

        }
    }else{
  this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});
    }}
    ,error : (err) => {
      // this.cpnr=null
      // this. PassengerArray=[]

      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});

    }}
    )
}
checkCancelManual(){
   return this.passengerUpdatedArray.some((item: any) =>
    item.pnr && item.pnr.trim() !== ''
  );
}
cancelManual(){
  this.confirmDisabled=true
  
  this.CartService
  .cancelManualOrder({pnr:this.cpnr,passengerDetails:this.passengerUpdatedArray,cancellationType:'M',itineraryId:this.PassengerArray[0]?.itineraryUuid,comment:this.comment,cancellationMode:this.cancellationMode},this.airData?.uuid)
  .subscribe({
    next : (res:any) => {
      if(res){
        if(res.result&&res.result[0].errorDetails){

          if(res.result[0].errorDetails.errorData.errorMessage){
            this.toastMsgService.setMsg({msg :res.result[0].errorDetails.errorData.errorMessage,msgTitle : "Cancellation Failed", msgType : "E"});

          }else{
            this.confirmDisabled=false
            this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});
          }

        }else{
      this.cpnr=null
     this.PassengerArray=[]
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg :'Success',msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)
      this.showAction=false

      this.showAmend=false
        }
    }else{
  this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});
    }}
    ,error : (err) => {
      // this.cpnr=null
      // this. PassengerArray=[]

      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});

    }}
    )
}
cancelOld(){
  this.confirmDisabled=true

  this.CartService
  .cancelOrder({pnr:this.cpnr,passengerDetails:this.PassengerArray,cancellationType:this.manualCancellation?('M'):'A'},this.airData?.uuid)
  .subscribe({
    next : (res:any) => {
      if(res){
        if(res.result&&res.result[0].errorDetails){

          if(res.result[0].errorDetails.errorData.errorMessage){
            this.toastMsgService.setMsg({msg :res.result[0].errorDetails.errorData.errorMessage,msgTitle : "Cancellation Failed", msgType : "E"});

          }else{
            this.confirmDisabled=false
            this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});
          }

        }else{
      this.cpnr=null
     this.PassengerArray=[]
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg :'Success',msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)
      this.showAction=false

      this.showAmend=false
        }
    }else{
  this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});
    }}
    ,error : (err) => {
      // this.cpnr=null
      // this. PassengerArray=[]

      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Cancel Request Failed",msgTitle : "Warning", msgType : "W"});

    }}
    )
}

reschedule(){
  this.confirmDisabled=true
 
  this.CartService
  .rescheduleOrder({pnr:this.cpnr,orderPassengerDetails:this.PassengerArray,itineraryId:this.PassengerArray[0]?.itineraryUuid,rescheduleType:this.manualreschedule,comment:this.comment},this.airData?.uuid)
  .subscribe({
    next : (res:any) => {
      this.cpnr=null
     this.PassengerArray=[]
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg :'Success',msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)
      this.showAction=false

      this.showAmend=false

    }
    ,error : (err) => {
      // this.cpnr=null
      // this. PassengerArray=[]

      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Reschedule Request Failed",msgTitle : "Warning", msgType : "W"});

    }}
    )
}
confirmAmendment(){
  this.confirmDisabled=true
 let request:any={ 
  "orderId":this.airData?.uuid,
 "String reason":this.comment,
 "amendType":"C",
 "data": {"pnr": this.pnr}}
  this.CartService
  .cancel(request)
  .subscribe({
    next : (res:any) => {
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : res?.message,msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)
       this.showAmend=false
     
    },error : (err) => {
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Amendment Request Failed",msgTitle : "Warning", msgType : "W"});
      // this.getOrder(this.cartUuid)

    }
  }
)
}




GetAmend(id:any){
  
   this.CartService
   .getAmendData(id)
   .subscribe({
     next : (res:any) => {
       if(res) {
      let data=res
      this.amendCartList=data
       } else {
       
       } 
     },error : (err) => {
 
     }
   }
 )
 }



 totalPrice(rule:any,markup:any){
  return Number(rule)+Number(markup)
 }
 disabled:boolean=false
  amendProcess(){
  for(let PassengerDetailItem of this.PassengerDetail){
    PassengerDetailItem.amendmentCharges.cancellationFees=PassengerDetailItem.feeMarkup
    PassengerDetailItem.amendmentCharges.supplierAmdFees=PassengerDetailItem.feeRules
  
   }
  this.disabled=true
  let passengerDetail :any[] = []
for(let i=0;i<this.PassengerDetail.length;i++) {
  passengerDetail.push(this.PassengerDetail[i]);
}
passengerDetail?.forEach((item:any)=>{
  delete item.flightDetailsList
  
})
let request:any={
  "cancellationCharges": {
      "cancellationFees":this.PassengerDetail.feeMarkup ,
      "otherCharges": 0.0,
      "supplierAmdFees":this.PassengerDetail.feeRules,
      
  },
  "passengerDetails":passengerDetail
}
  this.CartService
  .AmendData(request,this.AmendProcessDetail?.uuId)
  .subscribe({
    next : (res:any) => {
      this.disabled=false
      if(res) {
        this.getOrder(this.cartUuid)
        this.GetAmend(this.cartUuid)

        this.showAmendProcess=false
        this.toastMsgService.setMsg({msg : 'Success',msgTitle : "Success", msgType : "I"});

      } else {
      
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : 'Failed to Amend',msgTitle : "Warning", msgType : "W"});

      this.disabled=false

    }
  }
)
}
 amendOldProcess(){
  this.disabled=true
let request:any={
  "cancellationCharges": {
      "cancellationFees":this.PassengerDetail.feeMarkup ,
      "otherCharges": 0.0,
      "supplierAmdFees":this.PassengerDetail.feeRules 
  }
}
  this.CartService
  .AmendData(request,this.AmendProcessDetail?.uuId)
  .subscribe({
    next : (res:any) => {
      this.disabled=false
      if(res) {
        this.getOrder(this.cartUuid)
        this.GetAmend(this.cartUuid)

        this.showAmendProcess=false
        this.toastMsgService.setMsg({msg : 'Success',msgTitle : "Success", msgType : "I"});

      } else {
      
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : 'Failed to Amend',msgTitle : "Warning", msgType : "W"});

      this.disabled=false

    }
  }
)
}
showSpinners = true;        // Show spinners for time input
showSeconds = true;         // Allow seconds input
stepHour = 1;               // Hour step
stepMinute = 1;             // Minute step
stepSecond = 1;             // Second step
touchUi = false;            // Show in touch UI mode
color: 'primary' | 'accent' | 'warn' = 'primary'; // Date picker color
enableMeridian = false;      // 12-hour format (AM/PM)
disableMinute = false;      // Enable/disable minute input
hideTime = false;           // Hide time portion of the picker
amendRescheduledProcess(){
  let passenger:any=[]
  console.log(this.PassengerDetail)

  for(let PassengerDetailItem of this.PassengerDetail){
    PassengerDetailItem.rescheduleComponent={
      otherCharges:0.0,
      supplierAmendment:PassengerDetailItem.feeRules,
      baseFareCharges:PassengerDetailItem?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.baseFare||0,
      airlineTaxes:PassengerDetailItem?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.finalTax||0,
      rescheduledFees:PassengerDetailItem.feeMarkup
      }
    
    

  
   }

 if(this.amendSource==='GALELIO'){
  
  const hasMissingTicket = this.PassengerDetail.some((p:any) => !p.ticketNumber);
if(!hasMissingTicket){

  let passengerData:any={
    list: this.PassengerDetail
  }
   this.amendAirItineraries.rescheduleFlightData.passengerDetails= passengerData.list

   for(let Passengers of this.amendAirItineraries.rescheduleFlightData.passengerDetails){
  
    for(let item of Passengers.flightDetailsList ){
      // item.totaltaxes=0
    // item.totaltaxes=0

    item.classes.forEach((clas:any)=>{
      // passenger.push(clas)

       clas.fareDetails.passengerBookingClasses.forEach((fareDetails:any)=>{
        // fareDetails.fareDetailsPerPassengerType.finalTax=0
        if(fareDetails.fareDetailsPerPassengerType.taxes&&fareDetails.fareDetailsPerPassengerType.taxes?.length>0){
        
         this.updateTaxtempValue(fareDetails.fareDetailsPerPassengerType.taxes,fareDetails)
         fareDetails.fareDetailsPerPassengerType.taxes=this.arrayToObject(fareDetails.fareDetailsPerPassengerType.taxes)
         fareDetails.fareDetailsPerPassengerType.finalTax= fareDetails.totaltaxes   

        }
       
       })


    
  Passengers.fareDetails=item?.classes[0]?.fareDetails
       item.bookingClasses=[...item.classes]

     })
   
  

   }}


  this.disabled=true

this.amendAirItineraries.rescheduleFlightData.fare=[this.amendAirItineraries.rescheduleFlightData.fare]
this.amendAirItineraries.rescheduleFlightData.routeRequest=this.amendAirItineraries.flightDetails.routeRequest

  
 let request:any={
  itineraryId:this.amendAirItineraries?.uuid,
   amendmentId:this.AmendProcessDetail?.uuId,
  userBookingRequest:this.amendAirItineraries.rescheduleFlightData,
    // passengerDetails:[this.PassengerDetail],
  //   flightDetailsList:this.amendAirItineraries.repriceData.flightDetailsList,
  //   fare:[this.amendAirItineraries.repriceData.fare]

  // },
  "rescheduledCharges": {
    "rescheduledFees": this.PassengerDetail.feeMarkup,
    "otherCharges": 0.0,
    "supplierAmdFees":this.PassengerDetail.feeRules 
}
      // passengerDetails:[this.PassengerDetail]
    // }
    // flightDetailsList
    // passengerDetails

  
 }


this.CartService
.AmendRescheduleData(request,this.cartUuid)
.subscribe({
  next : (res:any) => {
    this.disabled=false
    if(res) {
      

      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)

      this.showAmendProcess=false
      this.toastMsgService.setMsg({msg : 'Success',msgTitle : "Success", msgType : "I"});

    } else {
    
    } 
  },error : (err) => {
    this.toastMsgService.setMsg({msg : 'Failed to Amend',msgTitle : "Warning", msgType : "W"});

    this.disabled=false


  }
}
)}else{
  this.disabled=false
  // this.getOrder(this.cartUuid)

  console.log('jkjkjj')
  this.toastMsgService.setMsg({msg : 'Ticket Number is missing field',msgTitle : "Warning", msgType : "W"});

}
 }
 else{
  let passengerData:any={
    list: this.PassengerDetail
  }

   this.amendAirItineraries.rescheduleFlightData.passengerDetails= passengerData.list

   for(let Passengers of this.amendAirItineraries.rescheduleFlightData.passengerDetails){
  
    for(let item of Passengers.flightDetailsList ){
      // item.totaltaxes=0
    // item.totaltaxes=0

    item.classes.forEach((clas:any)=>{
      // passenger.push(clas)
console.log(clas.fareDetails.passengerBookingClasses)
       clas.fareDetails.passengerBookingClasses.forEach((fareDetails:any)=>{
        // fareDetails.fareDetailsPerPassengerType.finalTax=0
        if(fareDetails.fareDetailsPerPassengerType.taxes&&fareDetails.fareDetailsPerPassengerType.taxes?.length>0){
// console.log(fareDetails.fareDetailsPerPassengerType.taxes)
        
         this.updateTaxtempValue(fareDetails.fareDetailsPerPassengerType.taxes,fareDetails)
         fareDetails.fareDetailsPerPassengerType.taxes=this.arrayToObject(fareDetails.fareDetailsPerPassengerType.taxes)
        //  console.log(fareDetails.fareDetailsPerPassengerType.taxes)

        fareDetails.fareDetailsPerPassengerType.finalTax= fareDetails.totaltaxes   
         }
       
       })
     })
     Passengers.fareDetails=item?.classes[0]?.fareDetails
     Passengers.bookingClasses=[...item.classes]
   
  

   }}
console.log(this.amendAirItineraries.rescheduleFlightData.passengerDetails)
  this.disabled=true

this.amendAirItineraries.rescheduleFlightData.fare=[this.amendAirItineraries.rescheduleFlightData.fare]
this.amendAirItineraries.rescheduleFlightData.routeRequest=this.amendAirItineraries.flightDetails.routeRequest

 let request:any={
  itineraryId:this.amendAirItineraries?.uuid,
   amendmentId:this.AmendProcessDetail?.uuId,
  userBookingRequest:this.amendAirItineraries.rescheduleFlightData,
    // passengerDetails:this.PassengerDetail,
  //   flightDetailsList:this.amendAirItineraries.repriceData.flightDetailsList,
  //   fare:[this.amendAirItineraries.repriceData.fare]

  // },
  "rescheduledCharges": {
    "rescheduledFees": this.PassengerDetail.feeMarkup,
    "otherCharges": 0.0,
    "supplierAmdFees":this.PassengerDetail.feeRules 
}
      // passengerDetails:[this.PassengerDetail]
    // }
    // flightDetailsList
    // passengerDetails

  
 }




  this.CartService
  .AmendRescheduleData(request,this.cartUuid)
  .subscribe({
    next : (res:any) => {
      this.disabled=false
      if(res) {
        

        this.getOrder(this.cartUuid)
        this.GetAmend(this.cartUuid)

        this.showAmendProcess=false
        this.toastMsgService.setMsg({msg : 'Success',msgTitle : "Success", msgType : "I"});

      } else {
      
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : 'Failed to Amend',msgTitle : "Warning", msgType : "W"});

      this.disabled=false


    }
  }
)}
}
amendOldRescheduledProcess(){
  let passenger:any=[]
  // this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.finalTax=0
  for(let item of this.amendAirItineraries.repriceData.flightDetailsList ){
    // item.totaltaxes=0

    item.classes.forEach((clas:any)=>{
      passenger.push(clas)

       clas.fareDetails.passengerBookingClasses.forEach((fareDetails:any)=>{
        fareDetails.fareDetailsPerPassengerType.finalTax=0
         this.updateTaxtempValue(fareDetails.fareDetailsPerPassengerType.taxes,fareDetails)
         fareDetails.fareDetailsPerPassengerType.taxes=this.arrayToObject(fareDetails.fareDetailsPerPassengerType.taxes)

        //  for(let items of fareDetails.fareDetailsPerPassengerType.taxes ){
        //    this.updateTotalTaxValue(items,fareDetails)
     
        //  }
       })
     })
   
    //  console.log( item.classes.fareDetailsPerPassengerType.taxes)
    //  item.classes.fareDetailsPerPassengerType.taxes=this.arrayToObject(item.classes.fareDetailsPerPassengerType.taxes)
    //  console.log( item.classes.fareDetailsPerPassengerType.taxes)
    //  item.bookingClasses[0]=JSON.parse(JSON.stringify(item.classes))


   }
   this.amendAirItineraries.repriceData.passengerDetails=passenger

  // for(let tax of this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes){
  //   this.updateTaxtempValue(tax)}
    // this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes=this.arrayToObject(this.PassengerDetail.fareDetails.passengerBookingClasses[0].fareDetailsPerPassengerType.taxes)

  this.disabled=true
// let request:any={
//   "cancellationCharges": {
//       "cancellationFees": this.PassengerDetail.feeRules,
//       "otherCharges": 0.0,
//       "supplierAmdFees": this.PassengerDetail.feeMarkup
//   }
// }
// this.amendAirItineraries.orderPassengerDetails=this.PassengerDetail
// console.log(this.amendAirItineraries.flightDetails)
// console.log(this.AmendProcessDetail)
// this.amendAirItineraries.repriceData.passengerDetails=[this.PassengerDetail]
this.amendAirItineraries.repriceData.fare=[this.amendAirItineraries.repriceData.fare]
this.amendAirItineraries.repriceData.routeRequest=this.amendAirItineraries.flightDetails.routeRequest

 let request:any={
  itineraryId:this.amendAirItineraries?.uuid,
   amendmentId:this.AmendProcessDetail?.uuId,
  userBookingRequest:this.amendAirItineraries.repriceData,
  //   passengerDetails:[this.PassengerDetail],
  //   flightDetailsList:this.amendAirItineraries.repriceData.flightDetailsList,
  //   fare:[this.amendAirItineraries.repriceData.fare]

  // },
  "rescheduledCharges": {
    "rescheduledFees": this.PassengerDetail.feeMarkup,
    "otherCharges": 0.0,
    "supplierAmdFees":this.PassengerDetail.feeRules 
}
      // passengerDetails:[this.PassengerDetail]
    // }
    // flightDetailsList
    // passengerDetails

  
 }
  this.CartService
  .AmendRescheduleData(request,this.cartUuid)
  .subscribe({
    next : (res:any) => {
      this.disabled=false
      if(res) {
        

        this.getOrder(this.cartUuid)
        this.GetAmend(this.cartUuid)

        this.showAmendProcess=false
        this.toastMsgService.setMsg({msg : 'Success',msgTitle : "Success", msgType : "I"});

      } else {
      
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : 'Failed to Amend',msgTitle : "Warning", msgType : "I"});

      this.disabled=false

    }
  }
)
}
passengerDetails(item:any){
  // console.log(item)
return item.filter((passenger:any)=>passenger.passengerType==='ADT')
}




generatePDF(invoiceLabel:any){
  this.FlightService
  .downloadCartPdf(this.airData?.uuid,invoiceLabel)
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
      //  console.log(data)
      var fileName = "Ticket_"+this.airData?.pnr.replace(',','_') + ".pdf";
var blob = data; // Assuming 'data' contains your PDF data
var file = new Blob([blob], { type: 'application/pdf' });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
a.download = fileName;

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
      } else {    
      } 
    },error : (err) => {


    }
  }
)
}
displayJSON(json:any) {
  let result:any=[...json] 
  result.forEach((item:any)=>{
    delete item.otherData;
    delete item.corporateFare;
    delete item.fareDetailsPerPassengerType.miscellaneousData;
    delete item.fareDetailsPerPassengerType.commercialData;
    delete item.seatsAvailability;
    delete item.passengerType;
    delete item.baggageInfo;
  })
 


//   if ("commercialData" in json && "miscellaneousData" in json && "seatsAvailability" in json && "passengerType" in json && "corporateFare" in json && "baggageInfo" in json && "otherData" in json  ) { 
//      // let container:any = document.getElementById('json-container');
//  }else{

//  }

const jsonString = JSON.stringify(result, null, 4)
        .replace(/[\[\]]/g, '')      // Remove square brackets
        .replace(/[{}]/g, '');      // Replace curly braces with commas

    // Replace "key": with <b>key</b>: for HTML bold
    const htmlFormatted = jsonString.replace(/"([^"]+)":/g, '<b>$1</b>:');

    return  `${htmlFormatted}`;;
//  return JSON.stringify(result, null, 4).replace(/[\[\]]/g, '');
}
// (/[\[\]{}]/g, '')
// displayWEJSON(result:any){
//   return JSON.stringify(result, null, 4)

// }
displayWEJSON(item: any): string {

  let result:any={ ...item }
delete result.baseFare;
delete result.finalTaxes;
delete result.taxComponentsAmount

  // Helper function to replace null with undefined
  const replaceNullWithUndefined = (obj: any): any => {
    if (obj === null) {
      return undefined;
    }
    if (Array.isArray(obj)) {
      return obj.map(replaceNullWithUndefined);
    }
    if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, replaceNullWithUndefined(value)])
      );
    }
    return obj;
    
  };

  // Replace null with undefined in the result object
  const modifiedResult = replaceNullWithUndefined(result);

  // Convert the modified result to a JSON string with 4-space indentation
  // return JSON.stringify(modifiedResult, (key, value) => value === undefined ? undefined : value, 4);

  const jsonString = JSON.stringify(modifiedResult, null, 4)
        .replace(/[\[\]]/g, '')      // Remove square brackets
        .replace(/[{}]/g, '');      // Replace curly braces with commas

    // Replace "key": with <b>key</b>: for HTML bold
    const htmlFormatted = jsonString.replace(/"([^"]+)":/g, '<b>$1</b>:');

    return  `${htmlFormatted}`;;
}

displaymarkcommJSON(item: any): string {

  let result:any={ ...item }

  // Helper function to replace null with undefined
  const replaceNullWithUndefined = (obj: any): any => {
    if (obj === null) {
      return undefined;
    }
    if (Array.isArray(obj)) {
      return obj.map(replaceNullWithUndefined);
    }
    if (typeof obj === 'object' && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, replaceNullWithUndefined(value)])
      );
    }
    return obj;
  };

  // Replace null with undefined in the result object
  const modifiedResult = replaceNullWithUndefined(result);

  // Convert the modified result to a JSON string with 4-space indentation
  // return JSON.stringify(modifiedResult, (key, value) => value === undefined ? undefined : value, 4);
  const jsonString = JSON.stringify(modifiedResult, null, 4)
        .replace(/[\[\]]/g, '')      // Remove square brackets
        .replace(/[{}]/g, '');      // Replace curly braces with commas

    // Replace "key": with <b>key</b>: for HTML bold
    const htmlFormatted = jsonString.replace(/"([^"]+)":/g, '<b>$1</b>:');

    return  `${htmlFormatted}`;
}






 emailData:any=[]
whatsAppData:any=[]
getSancharWhatsApp(id:any){
  
  this.CartService
  .getSancharWhatsApp(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.whatsAppData=data
    //  console.log(data)
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}

getSancharEmailApp(id:any){
  
  this.CartService
  .getSancharEmailApp(id)
  .subscribe({
    next : (res:any) => {
      if(res) {
     let data=res
     this.emailData=data
      } else {
      
      } 
    },error : (err) => {

    }
  }
)
}


// transform(value: string): string {
//   if (!value) {
//     return '';
//   }

//   // Use regex to remove all instances of { } and [ ] with their contents
//   return value.replace(/\{.*?\}/g, '').replace(/\[.*?\]/g, '');
// }

downloadTags(tags:any){
  this.CartService
  .downloadTags(tags)
  .subscribe({
    next : (res:any) => {
      if(res) {
       let data:any
       data=res  
      //  console.log(data)

     

      var fileName = tags;
var blob = data; // Assuming 'data' contains your PDF data

var mimeType;
let type:any
type=tags.split('.')[1]
    switch(type) {
        case 'pdf':
            mimeType = 'application/pdf';
            break;
        case 'image':
            mimeType = 'image/*'; // Change this to 'image/jpeg' for JPEG images
            break;
        case 'excel':
            mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            break;
            case 'eml':
                mimeType = 'message/rfc822';
                break;
            case 'msg':
                mimeType = 'application/vnd.ms-outlook';
                break;
        default:
            mimeType = 'application/octet-stream'; // Fallback for unknown types
    }

var file = new Blob([blob], { type: mimeType });

// Create a download link
var a = document.createElement("a");
a.href = window.URL.createObjectURL(file);
a.download = fileName;

// Append the link to the document
document.body.appendChild(a);

// Trigger a click on the link to start the download
a.click();

// Remove the link from the document after the download is initiated
document.body.removeChild(a);
      } else {    
      } 
    },error : (err) => {


    }
  }
)
}
pdfUrl:any
pdfDownloadUrl:any={
  uniqueId:'',
  url:''
}
showFinPdF:boolean=false
downloadFinBookPDF(item:any,uniqueId:any){
  this.pdfDownloadUrl={
    uniqueId:uniqueId,
    url:''
  }
  this.pdfUrl=null
  if(item){
    this.showFinPdF=true
  this.CartService.downloadFinBookPDF(item,uniqueId).subscribe({
    next: (response: Blob) => {
      console.log(response)
      const blob = new Blob([response], { type: 'application/pdf' });
      // const url = window.URL.createObjectURL(blob);
      this.pdfDownloadUrl.url=response;
      this.pdfDownloadUrl.uniqueId=uniqueId;

      const url = URL.createObjectURL(blob);
      const modifiedUrl = `${url}#view=FitH&navpanes=0&zoom=90`;

      this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(modifiedUrl);
    console.log(this.pdfUrl)
      // Open PDF in a new browser tab
      // window.open(url);
  
      // Optional: Revoke the object URL after some time to free memory
      // setTimeout(() => {
      //   window.URL.revokeObjectURL(url);
      // }, 100);
      this.showFinPdF=false

    },
    error: (err) => {
      this.showFinPdF=false

    }
  });
  // .subscribe({
  //   next: (response: Blob) => {
  //     const blob = new Blob([response], { type: 'application/pdf' });
  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement('a');
  //     a.href = url;
  //     a.download = 'Invoice'+'_'+uniqueId?.replace('/', '-')+'.pdf';
  //     a.click();
  //     window.URL.revokeObjectURL(url);
  //     this.showFinPdF=false

  //   },
  //   error: (err) => {
  //     this.showFinPdF=false

  //   }
  // });
}
 
}

refreshCSR(id:any){
  
  this.CartService
  .CSRResult(id)
  .subscribe({
    next : (res:any) => {
      this.getOrder(this.cartUuid)

      if(res) {
     let data=res

      } else {
        // this.getOrder(this.cartUuid)

      } 
    },error : (err) => {
      this.getOrder(this.cartUuid)

    }
  }
)
}
syncItinerary(id:any,itineraryId:any){
    let msg:any='Are you sure you want to Issue ticket ?'
  

  this.DialogService.open({msg : msg,title : "Confirmation",buttonType : "YesNo"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Yes") {
  let request:any={
    itineraryId:itineraryId,
    orderId:id
  }
  this.CartService
  .syncOrderItinerary(request)
  .subscribe({
    next : (res:any) => {
      if(res?.body) {
      if(res?.body?.success===true){
        this.startTimer()
      this.toastMsgService.setMsg({msg : res?.body?.message,msgTitle : "Success", msgType : "I"});

}else if(res?.body?.success===false){
        this.toastMsgService.setMsg({msg :res?.body?.message,msgTitle : "Warning", msgType : "W"});

}

      
      } else {
        this.toastMsgService.setMsg({msg : "Failed to Requested",msgTitle : "Warning", msgType : "W"});

      } 
            this.getOrder(this.cartUuid)

    },error : (err) => {
      this.getOrder(this.cartUuid)
      this.toastMsgService.setMsg({msg : "Failed to Requested",msgTitle : "Warning", msgType : "W"});


    }
  }
)
}})
}
 countdown: number = 15;
interval: any;
disabledSync:boolean=false
startTimer(): void {
  this.interval = setInterval(() => {
    if (this.countdown > 0) {
      this.countdown--;
      this.disabledSync=true
if(this.countdown===0){
      this.getOrder(this.cartUuid)

}
    } else {
      this.disabledSync=false
      clearInterval(this.interval);
this.countdown = 15;
      // Timer has completed. You can add more logic here if needed.
    }
  }, 1000); // 1000 milliseconds = 1 second

  
}

abortItinerary(item:any){
  let msg:any=''
  if(item==='A'){msg='Are you sure you want to Abort ?'}
    if(item==='V'){msg='Are you sure you want to Void ?'}

  this.DialogService.open({msg : msg,title : "Confirmation",buttonType : "YesNo"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Yes") {
  this.CartService
  .OrderItinerary(this.cartUuid)
  .subscribe({
    next : (res:any) => {
      this.toastMsgService.setMsg({msg : "Abort successful!",msgTitle : "Success", msgType : "I"});

      this.getOrder(this.cartUuid)

      if(res) {
     let data=res
      } else {

      } 
    },error : (err) => {
      this.getOrder(this.cartUuid)
      this.toastMsgService.setMsg({msg : "Abort failed. Please try again.",msgTitle : "Warning", msgType : "W"});


    }
  }
)
}})
}

patchItinerary(id:any,itineraryId:any){
  let request:any={
    itineraryId:itineraryId,
    orderId:id
  }
  this.CartService
  .patchOrderItinerary(request)
  .subscribe({
    next : (res:any) => {
      this.getOrder(this.cartUuid)

      if(res) {
     let data=res
      } else {

      } 
    },error : (err) => {
      this.getOrder(this.cartUuid)

    }
  }
)
}
patchPerPassengerItinerary(id:any,itineraryId:any,passenger:any){
  let request:any={
    itineraryId:itineraryId,
    orderId:id,
    orderPassengerDetails:passenger
  }
  if(request.orderPassengerDetails.ticketNumber){
  this.DialogService.open({msg : 'Are you sure you want to Update this('+request.orderPassengerDetails.ticketNumber+') Ticket Number ?',title : "Confirmation",buttonType : "YesNo"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Yes") {
  this.CartService
  .patchPassengerItinerary(request)
  .subscribe({
    next : (res:any) => {
      this.getOrder(this.cartUuid)
      this.toastMsgService.setMsg({msg : "Ticket Number Updated Successfully!",msgTitle : "Success", msgType : "I"});

      if(res) {
     let data=res
      } else {

      } 
    },error : (err) => {
      this.getOrder(this.cartUuid)
      this.toastMsgService.setMsg({msg : "Failed to Update Ticket Number!",msgTitle : "Warning", msgType : "W"});

    }
  }
)}})}else{
  this.toastMsgService.setMsg({msg : "Please Enter Ticket Number!",msgTitle : "Warning", msgType : "W"});

}
}

serviceData = [
  { number: 'Seat Number', Code: 'seatCode', type: 'Seat', },
  { number: 'Meal Code', Code: 'mealCode', type: 'Meal' },
  { number: 'Baggage Weight', Code: 'Baggage Weight', type: 'Extra Baggage' },
  { number: 'SSRCode', Code: 'SSR Description', type: 'Special SSR' },
  { number: 'Name', Code: 'EMD', type: 'EMD' },
  
  // { number: 'FastForward Code', Code: 'fastForwardDescription', type: 'Fast Forward' }
];

serviceControl = new FormControl();
selectedServices:any = [];
showPopup = false;

onMultiSelect() {
    this.selectedServices = this.serviceControl.value;

}
  // this.selectedServices = [...this.serviceControl.value,{ number: 'Ticket Number', Code: '', type: 'ticketNumber' }];

miscellaneousRequest:any={}
onShowMiscellaneous(id:any,itineraryId:any,passenger:any,source:any){
  this.MiscellaneousErrorMsg=''
  this.serviceControl = new FormControl();
  this.selectedServices=[]
    let request:any={
      itineraryId:itineraryId,
      orderId:id,
      orderPassengerDetails:passenger,
      source:source
    }
    this.miscellaneousRequest=request

  this.showPopup = true; // Display popup on multi-select change
  if(source==='GALELIO'){
    this.serviceData = [
      { number: 'Seat Number', Code: 'seatCode', type: 'Seat', },
      { number: 'Meal Code', Code: 'mealCode', type: 'Meal' },
      { number: 'Baggage Weight', Code: 'Baggage Weight', type: 'Extra Baggage' },
      { number: 'SSRCode', Code: 'SSR Description', type: 'Special SSR' },
      { number: 'Name', Code: 'EMD', type: 'EMD' },
    ];
  }else{
  this.serviceData = [
    { number: 'Seat Number', Code: 'seatCode', type: 'Seat', },
    { number: 'Meal Code', Code: 'mealCode', type: 'Meal' },
    { number: 'Baggage Weight', Code: 'Baggage Weight', type: 'Extra Baggage' },
    { number: 'SSRCode', Code: 'SSR Description', type: 'Special SSR' }
  
  ];}
}
isSaveDisabled(itineraries: any[]): boolean {
  const services = this.serviceControl.value || [];

  if (this.disabledMiscellaneous || services.length === 0) {
    return true;
  }

  const isServiceSelected = (type: string, number?: string) =>
    services.some((service:any) =>
      service.type === type || service.number === number
    );

  const seatSelected = isServiceSelected('Seat', 'Seat Number');
  const mealSelected = isServiceSelected('Meal', 'Meal Code');
  const baggageSelected = isServiceSelected('Extra Baggage', 'Baggage Weight');
  const ssrSelected = isServiceSelected('Special SSR', 'SSRCode');
  const emdSelected = isServiceSelected('EMD', 'Name');

  for (const itinerary of itineraries) {
    // ✅ NEW CONDITION: If source is 'gail', ticketNo is mandatory
    // if (this.miscellaneousRequest?.source === 'GALELIO' && !itinerary.ticketNo?.trim()) {
    //   return true;
    // }

    // ✅ Ticket number required only if specific service is selected
    if (
      (this.miscellaneousRequest?.source === 'GALELIO'&&seatSelected && !itinerary.seatTicketNumber?.trim()) ||
      (this.miscellaneousRequest?.source === 'GALELIO' &&mealSelected && !itinerary.mealTicketNumber?.trim()) ||
      (this.miscellaneousRequest?.source === 'GALELIO' &&baggageSelected && !itinerary.baggageSsrTicketNumber?.trim()) ||
      (this.miscellaneousRequest?.source === 'GALELIO' &&ssrSelected && !itinerary.specialSsrTicketNumber?.trim()) ||
      (this.miscellaneousRequest?.source === 'GALELIO' &&emdSelected && !itinerary.emdTicketNumber?.trim())
    ) {
      return true;
    }
  }

  return false; // All checks passed, Save button enabled
}

disabledMiscellaneous:boolean=false
MiscellaneousErrorMsg:any=''
updateMiscellaneous(){
this.disabledMiscellaneous=true
  this.CartService
  .MiscellaneousItinerary(this.miscellaneousRequest)
  .subscribe({
    next : (res:any) => {
      this.disabledMiscellaneous=false

      let data:any=res?.body||null
      
if(data?.error?.message){
  this.MiscellaneousErrorMsg=data?.error?.message
      this.toastMsgService.setMsg({msg : "Failed to Update Miscellaneous Data",msgTitle : "Warning", msgType : "W"});

}else{
      this.showPopup = false; 
            this.toastMsgService.setMsg({msg : "Miscellaneous Data Updated Successfully!",msgTitle : "Success", msgType : "I"});

}
      this.getOrder(this.cartUuid)

     
    },error : (err) => {
      this.disabledMiscellaneous=false

      this.getOrder(this.cartUuid)
      this.toastMsgService.setMsg({msg : "Failed to Update Miscellaneous Data",msgTitle : "Warning", msgType : "W"});

    }
  }
)
}

closeMiscellaneous() {
  // Handle save logic here
  // console.log('Selected services saved:', this.selectedServices);
  this.showPopup = false; // Close the popup after saving
}

objectToArray(obj:any) {
  // console.log()
  let array:any=[]
  if(obj&&Object.keys(obj)){
    array=Object.entries(obj).map(([key, value]) => ({
    key: key,
    value: value  // 'value' is now recognized as a number[]
  }));
  return array
}
return []
  
}
arrayToObject(obj:any){
 let array:any = {};
 if(obj.length>0){
for (let key in obj) {

  if (obj.hasOwnProperty(key)) {
    array[obj[key]['key']]=[Number(obj[key]['tempValue'])]
  }
}

return array}
return array
}
updateTotalTaxValue(tax: any,item:any) {
  // tax.tempValue = this.addTotal(tax.tempValue); 
if( tax.tempValue ){
  // console.log(tax.tempValue)

    item.totaltaxes+=Number(tax.tempValue)
      

}
}
updateTaxValue(tax: any,item:any) {
  tax.tempValue = this.addTotal(tax.value); 
if( tax.tempValue ){
  // console.log(tax.tempValue)

    item.totaltaxes+=Number(tax.tempValue)
  
}
}
addTotal(data:any){
  if(data&&data.length>0){
    let total:any=0
    for(let item of data ){

total+=Number(item)
console.log(total)

    }
    return total

  }
  return 0

}
updateTaxtempValue(tax: any,item:any) {
  // tax.value = tax.tempValue; // Update the actual value when "Save" is clicked
  // console.log(tax)
    for(let items of tax)
    if( items.tempValue ){

      item.fareDetailsPerPassengerType.finalTax+=Number(items.tempValue)

  }
}
TotalRescheduleAmount=0
ChangeTotalTax(){
  this.TotalRescheduleAmount=0
  let totalRescheduleAmount=0
  for(let Passengers of this.PassengerDetail){
  const baseFare = Passengers?.rescheduleComponent?.baseFareCharges ?? 0;
  const airlineTaxes = Passengers?.rescheduleComponent?.airlineTaxes ?? 0;
  totalRescheduleAmount += baseFare + airlineTaxes;
  for(let item of Passengers.flightDetailsList ){
    // item.totaltaxes=0
    //  item.classes={...item.bookingClasses[0]}
      // item.classes.fareDetailsPerPassengerType.taxes=this.arrayToObject(item.classes.fareDetailsPerPassengerType.taxes)

    //  item.classes.fareDetailsPerPassengerType.taxes=this.objectToArray(item.classes.fareDetailsPerPassengerType.taxes)
    item.classes.forEach((clas:any)=>{
     let total=0
     if('passengerBookingClasses' in clas.fareDetails){
      clas.fareDetails.passengerBookingClasses.forEach((fareDetails:any)=>{
        fareDetails.totaltaxes=0
        for(let items of fareDetails.fareDetailsPerPassengerType.taxes ){
          this.updateTotalTaxValue(items,fareDetails)
    
        }
        this.TotalRescheduleAmount+=fareDetails.totaltaxes+Number(fareDetails.fareDetailsPerPassengerType.baseFare?(fareDetails.fareDetailsPerPassengerType.baseFare):0)
      })}
    })
    // for(let items of item.classes.fareDetailsPerPassengerType.taxes ){
    //    this.updateTotalTaxValue(items,item)
 
    //  }

   }

  }
if(this.viewEdit){
   this.TotalRescheduleAmount=totalRescheduleAmount

}else{
   this.TotalRescheduleAmount=Number(this.TotalRescheduleAmount)-Number(this.currentTotalVaue)

}

}

ChangeOldTotalTax(){
  this.TotalRescheduleAmount=0

  for(let item of this.amendAirItineraries.repriceData.flightDetailsList ){
    // item.totaltaxes=0
    //  item.classes={...item.bookingClasses[0]}
      // item.classes.fareDetailsPerPassengerType.taxes=this.arrayToObject(item.classes.fareDetailsPerPassengerType.taxes)

    //  item.classes.fareDetailsPerPassengerType.taxes=this.objectToArray(item.classes.fareDetailsPerPassengerType.taxes)
    item.classes.forEach((clas:any)=>{
     let total=0
      clas.fareDetails.passengerBookingClasses.forEach((fareDetails:any)=>{
        fareDetails.totaltaxes=0
        for(let items of fareDetails.fareDetailsPerPassengerType.taxes ){
          this.updateTotalTaxValue(items,fareDetails)
    
        }
        this.TotalRescheduleAmount+=fareDetails.totaltaxes+Number(fareDetails.fareDetailsPerPassengerType.baseFare?(fareDetails.fareDetailsPerPassengerType.baseFare):0)
      })
    })
    // for(let items of item.classes.fareDetailsPerPassengerType.taxes ){
    //    this.updateTotalTaxValue(items,item)
 
    //  }

   }

   this.TotalRescheduleAmount=Number(this.TotalRescheduleAmount)-Number(this.currentTotalVaue)

}
updateTicketData(){
  this.advancedPricingDataList.forEach((item:any)=>{
    item.advancedPricingList=item.agentTicketMarkUpData.filter((item:any) => item !== null)
  })
this.advancedPricingDataList=this.advancedPricingDataList.filter((item:any)=>item.advancedPricingList.length!==0)
this.UpdateAgentTicket()
}
downloadAgentTicket(C:any,pricing:any){

    this.FlightService
    .downloadAgentPdf(this.airData?.uuid,C,pricing)
    .subscribe({
      next : (res:any) => {
        if(res) {
         let data:any
         data=res  
        //  console.log(data)
        var fileName = "Ticket_"+this.airData?.pnr.replace(',','_') + ".pdf";
  var blob = data; // Assuming 'data' contains your PDF data
  var file = new Blob([blob], { type: 'application/pdf' });
  
  // Create a download link
  var a = document.createElement("a");
  a.href = window.URL.createObjectURL(file);
  a.download = fileName;
  
  // Append the link to the document
  document.body.appendChild(a);
  
  // Trigger a click on the link to start the download
  a.click();
  
  // Remove the link from the document after the download is initiated
  document.body.removeChild(a);
        } else {    
        } 
      },error : (err) => {
  
  
      }
    }
  )
  
}
pricing:boolean=true
inputText:any=''
showInput:boolean=false
advancedPricingDataList:any=[]
advanceTotal:any=0
SubmitAdvancePricing(event: Event, flightsItemIndex: number, passengerType: string, field: string, index: number) {
  // console.log(event)
    let value:any = (event.target as HTMLInputElement).value;
    // let value:any = event
    console.log(this.advancedPricingDataList)

    const pricingData = this.advancedPricingDataList[flightsItemIndex].agentTicketMarkUpData;

  console.log(pricingData)
    if (!pricingData[index]) {
      pricingData[index] = { passengerType, feeAmt: 0, baseAmt: 0, taxAmt: 0 };
    }
  pricingData[index][field] = parseFloat(value||0);
  
  
    this.advanceTotal=0
    this.advancedPricingDataList.forEach((item:any)=>{
      item.agentTicketMarkUpData.forEach((price:any)=>{
        
        this.advanceTotal+=Number(price.baseAmt)+Number(price.feeAmt)+Number(price.taxAmt)
  
      })
    })
    
  }
  travellerArray(item:any,data:any,passengerType:any){

    let traveller=[]
    if(item){
     
  
    for(let i=0;i<item;i++){
      traveller.push(this.changeAdvancedPricing(data,passengerType)[0])
  
    }
    
    // for(let item of traveller){
    //   this.advanceTotal+=Number(item.baseAmt)+Number(item.feeAmt)+Number(item.taxAmt)
  
    // }
  }
  
     
    return traveller
  }
  changeAdvancedPricing(item:any,passengerType:any)
{
  // console.log(item.filter((item:any)=>item.passengerType===passengerType))

return item
return item.filter((items:any)=>items.passengerType===passengerType)

}
showSidebar:boolean=false
showSideBar(){
  this.showSidebar=true
}


UpdateAgentTicket(){
let request:any={
  orderId:this.airData?.uuid,
  advancedPricingSegmentList:this.advancedPricingDataList
}
  this.FlightService
  .UpdateAgentmarkup(request)
  .subscribe({
    next : (res:any) => {
      this.showInput=false

      if(res) {
       let data:any
       data=res  
      //  console.log(data)
            this.toastMsgService.setMsg({msg : "Markup  Updated Successfully!",msgTitle : "Success", msgType : "I"});

      } else {    
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : "Failed to Updated Markup",msgTitle : "Warning", msgType : "W"});


    }
  }
)

}
// removeFlightSegment(index: number,PassengerDetails:any): void {
  
//   if (PassengerDetails.flightDetailsList.length > 1) {
//     PassengerDetails.flightDetailsList.splice(index , 1); 
//   }
//       this.ChangeTotalTax()

// }
// addFlightSegment(index: number,PassengerDetails:any): void {
//   const newSegment =  JSON.parse(JSON.stringify(PassengerDetails.flightDetailsList[index])); // Clone the selected item
//   PassengerDetails.flightDetailsList.splice(index + 1, 0, newSegment); // Insert after clicked index
//     this.ChangeTotalTax()

// }




onchangeCancelSupplierFee(){
  this.PassengerDetail.feeMarkup=0
  this.PassengerDetail.feeRules=0

  for(let PassengerDetailItem of this.PassengerDetail){
   
    this.PassengerDetail.feeMarkup+=Number(PassengerDetailItem?.feeMarkup)||0
    this.PassengerDetail.feeRules+=Number(PassengerDetailItem?.feeRules)||0
    
   }
}
notesRequest:any={
  scop:false,
  notes:''
}
disableNotes:boolean=false
blankNotes()
{
  this.notesRequest={
    scop:false,
    notes:''
  }
}
saveNotes(noteOp:any){
  this.disableNotes=true
  let request:any={
    orderId:this.airData?.uuid,
    
      "orderUuId":this.airData?.uuid,
      // "orderItineraryUuId": "ITN-98765",
      // "type": "",                        // will default to "M"
      // "source": "AdminPanel",
      "scope": this.notesRequest?.scop?'C':'O',
      // "user": "user123",
      // "userName": "John Doe",
      "description":this.notesRequest?.notes,
      // "activity": "Booking created",
    
    
  }

    this.FlightService
    .notesSave(request)
    .subscribe({
      next : (res:any) => {
        this.notesRequest={
          scop:false,
          notes:''
        }
        this.disableNotes=false

        this.toastMsgService.setMsg({msg : "Notes  Save Successfully!",msgTitle : "Success", msgType : "I"});
        noteOp.hide();
        if(res) {
         let data:any
         data=res  
        //  console.log(data)
            

        } else {    
        } 
      },error : (err) => {
        this.disableNotes=false
        
        this.toastMsgService.setMsg({msg : "Failed to Save Notes ",msgTitle : "Warning", msgType : "W"});
  
  
      }
    }
  )
}
checkOperationCharge(operation:any){
  let item:any=[]
   if(operation){
  item=operation.filter((operationItems:any)=>operationItems.operation==='Charge')}
    return item

}
checkOperationRefund(operation:any){
  
  let item:any=[]
  if(operation){
  item=operation.filter((operationItems:any)=>operationItems.operation==='Refund'||operationItems.operation==='Refunded')}
  return item
}
checkRefund(){
return  this.airData.airItineraries.some((item:any)=>item.payment.find((operationItem:any)=>operationItem.operation==='Refund'||operationItem.operation==='Refunded'))
}
checkCharge(){
  return this.airData.airItineraries.some((item:any)=>item.payment.find((operationItem:any)=>operationItem.operation==='Charge'))
}
checkReverseButton(){
  return  this.airData.airItineraries.some((item:any)=>item.payment.find((operationItem:any)=>operationItem.operation==='Refund'))

}
checkShowAbort(){
    return this.airData.airItineraries.some((item:any)=>item.status==='F'||item.status==='T')

}
checkIteCharge(itinerarie:any){
  return itinerarie?.payment?.some((operationItem:any)=>operationItem.operation==='Charge')
}
checkIteRefund(itinerarie:any){
  return itinerarie?.payment?.some((operationItem:any)=>operationItem.operation==='Refund'||operationItem.operation==='Refunded')

}
RefundPayment(){
  this.DialogService.open({msg : 'Are you sure you want to execute Reverse ?',title : "Confirmation",buttonType : "YesNo"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Yes") {
   let   request:any={
    "orderId":this.cartUuid
   }
  this.CartService
  .OrderReverse(request)
  .subscribe({
    next : (res:any) => {
      this.toastMsgService.setMsg({msg : "Reverse successful!",msgTitle : "Success", msgType : "I"});

      this.getOrder(this.cartUuid)

      if(res) {
     let data=res
      } else {

      } 
    },error : (err) => {
      this.getOrder(this.cartUuid)
      this.toastMsgService.setMsg({msg : "Reverse failed. Please try again.",msgTitle : "Warning", msgType : "W"});


    }
  }
)
}})
}
RefundGatewayPayment(){
  this.DialogService.open({msg : 'Are you sure you want to execute Refund ?',title : "Confirmation",buttonType : "YesNo"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Yes") {
   let   request:any={
    "orderId":this.cartUuid
   }
  this.CartService
  .OrderReverse(request)
  .subscribe({
    next : (res:any) => {
      this.toastMsgService.setMsg({msg : "Refund successful!",msgTitle : "Success", msgType : "I"});

      this.getOrder(this.cartUuid)

      if(res) {
     let data=res
      } else {

      } 
    },error : (err) => {
      this.getOrder(this.cartUuid)
      this.toastMsgService.setMsg({msg : "Refund failed. Please try again.",msgTitle : "Warning", msgType : "W"});


    }
  }
)
}})
}
viewGatewayInfo=false
paymentGatewayDetails:any;
showGatewaySpinner:boolean=false
viewGatewayPayment(item:any){
 this.viewGatewayInfo=true
  this.showGatewaySpinner=true

  this.CartService
  .viewGatewayPayment(item.pgOrderId,this.airData?.paymentMedium)
  .subscribe({
    next : (res:any) => {
              this.showGatewaySpinner=false

let data:any
data=res?.body||null
      if(data) {
        this.paymentGatewayDetails=data||null

      } else {

      } 
    },error : (err) => {

              this.showGatewaySpinner=false

    }
  }
)

}

showAutoReschedule:boolean=false
passengerRescheduleDetails:any={
  adt:0,
  chd:0,
  inf:0,

}
autoReschedule(){
let count:any=1
  let totalCount:any=1
 let searchDetail:any={}


 let  airSearchRequestBaseDetails:any=[]
      searchDetail={
        "requestedDate": this.sector.schDepartureTime,
        "requestedClass": this.airData?.cabinClass,
        "fromAirport": this.sector.fromAirport,
        "toAirport": this.sectorlastflight,
}

    airSearchRequestBaseDetails=[searchDetail]

this.PassengerArray.filter
let adults = this.PassengerArray.filter((p:any) => p.passengerType === 'ADT')?.length;
let children = this.PassengerArray.filter((p:any) => ['CHD', 'CH', 'CNN'].includes(p.passengerType))?.length;
let infants = this.PassengerArray.filter((p:any) => ['INF', 'IN'].includes(p.passengerType))?.length;
this.passengerRescheduleDetails={
   adt:adults||0,
  chd:children||0,
  inf:infants||0,
}
let data:any
    data={
      "airSearchRequestBaseDetails": airSearchRequestBaseDetails,
      "journeyType":'oneWay',
      "paxCount": totalCount,
      "adultCount": adults||0,
      "childCount": children||0,
      "infantCount": infants||0,
  }
 data.pointerEvents=true
 data.reschedule=true
data.itineraryUuid =this.PassengerArray[0]?.itineraryUuid
data.passengerId=this.PassengerArray.map((p: any) => p.id)
data.cartUuid=this.cartUuid
  // data.travelType=this.travelDetails.travelType
// data.otherList=this.otherList
// data.cabLocation=this.cabLocation
// data.hotelLocation=this.hotelLocation
  this.DataService.deliverMsg(data)
  this.showAutoReschedule=true
  // this.router.navigate(["/app/flightlist"]);
//   this.myOutput.emit(this.outputMessage);
//   data.document=this.file||''

    // this.router.navigate(["/app/flightlist"]);
    this.closePopup()

;
}
backRescheduleClick(){
    this.showAutoReschedule=false
}
isAnyTicketNumberInvalidC(): boolean {
  return this.PassengerDetail?.some((passenger: any) =>
    !passenger.ticketNumber || passenger.ticketNumber.trim() === ''||
    passenger.ticketNumber.trim().length !== 13
  );
}
pushToFin(id:any){
  this.DialogService.open({msg : 'Are you sure you want to Complete the Process?',title : "Confirmation",buttonType : "YesNo"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Yes") {
   let   request:any={
    "amendmentId":id
   }
  this.CartService
  .pushToFin(request)
  .subscribe({
    next : (res:any) => {
      this.toastMsgService.setMsg({msg : res?.body?.message,msgTitle : "Success", msgType : "I"});

      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)

      if(res) {
     let data=res
      } else {

      } 
    },error : (err) => {
      this.getOrder(this.cartUuid)
            this.GetAmend(this.cartUuid)

      this.toastMsgService.setMsg({msg : err?.error?.message,msgTitle : "Warning", msgType : "W"});


    }
  }
)
}})
}
pushToCancelFin(id:any){
  this.DialogService.open({msg : 'Are you sure you want to Complete the Process?',title : "Confirmation",buttonType : "YesNo"})
  this.DialogService.onResponse((response :  string) => {
   
    if(response=="Yes") {
   let   request:any={
    "amendmentId":id
   }
  this.CartService
  .pushToCancelFin(request)
  .subscribe({
    next : (res:any) => {
      this.toastMsgService.setMsg({msg : res?.body?.message,msgTitle : "Success", msgType : "I"});

      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)

      if(res) {
     let data=res
      } else {

      } 
    },error : (err) => {
      this.getOrder(this.cartUuid)
            this.GetAmend(this.cartUuid)

      this.toastMsgService.setMsg({msg : err?.error?.message,msgTitle : "Warning", msgType : "W"});


    }
  }
)
}})
}




isAnyTicketNumberInvalid(): boolean {

  const hasInvalidTicket = this.amendAirItineraries.some((itinerary: any) =>
  itinerary.PassengerDetail?.some((passenger: any) =>
    !passenger?.ticketNumber || passenger?.ticketNumber?.trim()?.length !== 13
  )
);
return hasInvalidTicket
  // return this.PassengerDetail?.some((passenger: any) =>
  //   !passenger.ticketNumber || passenger.ticketNumber.trim() === ''
  // );
}
isSourceGALELIO(): boolean {
  return this.amendAirItineraries.some((item:any)=>item.amendSource==='GALELIO')
}
rescheduleNEW(){
  this.confirmDisabled=true
 
  this.CartService
  .rescheduleOrder({orderPassengerDetails:this.PassengerArray,rescheduleType:this.airData?.cartType,comment:this.comment},this.airData?.uuid)
  .subscribe({
    next : (res:any) => {
      this.cpnr=null
     this.PassengerArray=[]
      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg :'Success',msgTitle : "Success", msgType : "I"});
      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)
      this.showAction=false
this.showActionTabs=false

      this.showRescheduleAmend=false

    }
    ,error : (err) => {
      // this.cpnr=null
      // this. PassengerArray=[]

      this.confirmDisabled=false
      this.toastMsgService.setMsg({msg : "Reschedule Request Failed",msgTitle : "Warning", msgType : "W"});

    }}
    )
}
showRescheduleAmend:boolean=false
OpenResAmend(type:any,pnrdata:any,pnrObject:any){
  this.cancelmsg=''
  this.cancellationMode=''
 this.manualCancel=false
   this.PassengerArray=pnrObject
  this.cpnr=pnrdata.join()
  // this.pnr=pnr
  this.comment=''
  this.showRescheduleAmend=true
  this.amendmentType=type
  // this.sector=item

  // this.sectorlastflight=lastSector
  this.manualCancellation=false
this.manualreschedule=false

}
showActionTabs:boolean=false
passengerflightDetails:any=[]
PassengerRescheduleObject:any=[]
 selectedReschedulePnr:any=[]

itinerariesSelect(element:any,flights:any){


 this.selectedReschedulePnr=[]
  // this.PassengerObject=flights?.orderPassengerDetails.filter((item:any) => item.showAction === true)
//   this.passengerflightDetails=this.rescheduleAirData?.filter((flight: any) =>
//   flight?.orderPassengerDetails?.some((item: any) => item.showAction === true)
// );
this.passengerflightDetails = this.rescheduleAirData
  ?.filter((flight: any) =>
    flight?.orderPassengerDetails?.some((item: any) => item.showAction === true)
  )
  .map((flight: any) => ({
    ...flight,
    orderPassengerDetails: flight.orderPassengerDetails.filter((item: any) => item.showAction === true)
  }));
console.log(this.passengerflightDetails)
this.PassengerRescheduleObject=this.rescheduleAirData
  ?.map((flight: any) =>
    flight?.orderPassengerDetails?.filter((item: any) => item.showAction === true) || []
  ).flat();
  flights?.orderPassengerDetails.filter((item:any) =>{
    if(item.showAction === true){
      this.selectedReschedulePnr.push(item.pnr)
    }
        })
 if (element.showAction === true) {
    flights.showAction = true;
        this.showActionTabs = true;

  } else {
    const anySelected = flights?.orderPassengerDetails.some((item: any) => item.showAction === true);
    flights.showAction = anySelected;
    const hasShowAction = this.rescheduleAirData?.some((flightss: any) =>flightss?.orderPassengerDetails?.some((item: any) => {
     
    return  item.showAction === true
    
    }));
    this.showActionTabs=hasShowAction
  }

  // this.passengerflightDetails=flights?.filter((item:any) => item.showAction === true)



}
onchangeSupplierFee(){
  
    for(let amendAirItinerariesItem of this.amendAirItineraries){

  amendAirItinerariesItem.PassengerDetail.feeMarkup=0
  amendAirItinerariesItem.PassengerDetail.feeRules=0

  for(let PassengerDetailItem of amendAirItinerariesItem.PassengerDetail){
   
    amendAirItinerariesItem.PassengerDetail.feeMarkup+=Number(PassengerDetailItem?.feeMarkup)||0
    amendAirItinerariesItem.PassengerDetail.feeRules+=Number(PassengerDetailItem?.feeRules)||0
    
   }}
}
removeFlightSegment(index: number,PassengerDetails:any): void {
  
  if (PassengerDetails.flightDetailsList.length > 1) {
    PassengerDetails.flightDetailsList.splice(index , 1); 
      this.ChangeRescheduleTotalTax()

  }
}
addFlightSegment(index: number,PassengerDetails:any): void {
  const newSegment =  JSON.parse(JSON.stringify(PassengerDetails.flightDetailsList[index])); // Clone the selected item
  PassengerDetails.flightDetailsList.splice(index + 1, 0, newSegment); // Insert after clicked index
    this.ChangeRescheduleTotalTax()

}

rescheduleAirData:any=[]
checkResch(data:any): any[] {
  return (data?.airItineraries || []).filter((flight:any) =>
    (flight.orderPassengerDetails || []).some((passenger:any) =>
      passenger.pnrStatus === 'HK' || passenger.pnrStatus === 'OK'
    )
  );
  
}



onClickAmmend(ite:any,viewEdit:any){
console.log(ite)
  this.AmendProcessDetail=ite
  this.viewEdit = viewEdit === 'view' ? true : false;


if(ite.type==='Reschedule'){
this.amendAirItineraries = this.airData.airItineraries.filter((item: any) =>
  ite?.itineraryGroup?.newItinerary.some((i: any) => i.itineraryUuid === item.uuid)
)||[];
for(let amendAirItinerariesItem of this.amendAirItineraries){

amendAirItinerariesItem.currentCabinClass=JSON.parse(JSON.stringify(amendAirItinerariesItem?.cabinClass))
if(amendAirItinerariesItem){
  amendAirItinerariesItem.amendSource=amendAirItinerariesItem.flightDetails.source||''
  this.amendSource=amendAirItinerariesItem.flightDetails.source||''
}


  this.onClickRescheduleAmendPro(ite,viewEdit,amendAirItinerariesItem)}

}else{
     this.onClickRescheduleAmendPro(ite,viewEdit,'')
  }
}
showAmendRescheduleProcess:boolean=false
onClickRescheduleAmendPro(ite:any,viewEdit:any,amendAirItinerariesItem:any){

// console.log(this.AmendProcessDetail)
if(ite.type==='Reschedule'){
  
  // this.amendAirItineraries=this.airData.airItineraries.filter((item:any)=>item.uuid.includes( this.AmendProcessDetail?.rescheduledItineraryUuid))

  // this.PassengerDetail=this.amendAirItineraries.orderPassengerDetails.filter((item:any)=>item.itineraryUuid===this.AmendProcessDetail?.rescheduledItineraryUuid)

// amendAirItinerariesItem.PassengerDetail=amendAirItinerariesItem?.orderPassengerDetails?.filter((item: any) =>
//   ite?.itineraryGroup?.newItinerary.some((i: any) => i.passengersIds.some((passengersId:any)=>passengersId === item.id))
// );

amendAirItinerariesItem.PassengerDetail =
  amendAirItinerariesItem?.orderPassengerDetails?.filter(
    (item: any) =>
      ite?.itineraryGroup?.newItinerary?.some(
        (i: any) =>
          i?.passengersIds?.some(
            (passengerId: any) => passengerId === item.id
          )
      )
  ) || [];

  amendAirItinerariesItem.PassengerDetail.ticketNumber=null
  amendAirItinerariesItem.PassengerDetail.feeMarkup=ite?.amendmentCharges?.rescheduledFees||0
  amendAirItinerariesItem.PassengerDetail.feeRules=ite?.amendmentCharges?.supplierAmdFees||0
 for(let PassengerDetailItem of amendAirItinerariesItem.PassengerDetail){
  PassengerDetailItem.feeMarkup=PassengerDetailItem?.rescheduleComponent?.rescheduledFees
  PassengerDetailItem.feeRules=PassengerDetailItem?.rescheduleComponent?.supplierAmendment
 }
}else {
  this.amendAirItineraries=this.airData.airItineraries.filter((item:any)=>item.pnr.includes( this.AmendProcessDetail?.refId))

  this.amendAirItineraries=this.amendAirItineraries[0]

  // this.PassengerDetail=this.amendAirItineraries.orderPassengerDetails.filter((item:any)=>item.pnr===this.AmendProcessDetail?.refId)
  
  this.PassengerDetail=this.AmendProcessDetail?.passengerList
  this.PassengerDetail.ticketNumber=null
  this.PassengerDetail.feeMarkup=ite?.amendmentCharges?.cancellationFees||0
  this.PassengerDetail.feeRules=ite?.amendmentCharges?.supplierAmdFees||0
 for(let PassengerDetailItem of this.PassengerDetail){
  PassengerDetailItem.feeMarkup=PassengerDetailItem?.amendmentCharges?.cancellationFees
  PassengerDetailItem.feeRules=PassengerDetailItem?.amendmentCharges?.supplierAmdFees
 }
}
 
  this.lastAmend=this.amendAirItineraries?.flightDetails?.flightDetailsList[this.amendAirItineraries?.flightDetails?.flightDetailsList.length - 1]
  
  this.showAmendRescheduleProcess=true
  
  let currentTotal:any=0

for (let p = 0; p < amendAirItinerariesItem.PassengerDetail.length; p++) {
  if(ite.type==='Reschedule'){
  
  amendAirItinerariesItem.PassengerDetail[p].flightDetailsList = amendAirItinerariesItem?.rescheduleFlightData?.flightDetailsList || [];}
else{
    this.PassengerDetail[p].flightDetailsList = this.amendAirItineraries?.repriceData?.flightDetailsList || [];

}
  for (let i = 0; i < amendAirItinerariesItem.PassengerDetail[p].flightDetailsList.length; i++) {
    let flight = amendAirItinerariesItem.PassengerDetail[p].flightDetailsList[i];
console.log('+++++',flight)
    // Prevent potential undefined errors
    if (!flight.bookingClasses || flight.bookingClasses.length === 0) {
      console.warn("Missing bookingClasses data for flight:", flight);
      continue; // Skip this iteration if bookingClasses is undefined or empty
    }

    let clonedPassenger = JSON.parse(JSON.stringify(amendAirItinerariesItem.PassengerDetail[p]));

    flight.PassengerDetail = [
      {
        ...clonedPassenger,
        fareDetails: {
          ...clonedPassenger.fareDetails,
          passengerBookingClasses: flight?.bookingClasses||[]
          // clonedPassenger.fareDetails.passengerBookingClasses.filter((item: any,i:number) =>
          //   item.fareDetailsPerPassengerType.baseFare === flight.bookingClasses[i]?.fareDetailsPerPassengerType?.baseFare &&
          //   item.fareDetailsPerPassengerType.finalTax === flight.bookingClasses[i]?.fareDetailsPerPassengerType?.finalTax &&
          //   item.bookingClass === flight.bookingClasses[i]?.bookingClass
          // )
        }
      }
    ];
    console.log( flight.PassengerDetail)

  }

}
for(let Passengers of amendAirItinerariesItem.PassengerDetail){

  for(let item of Passengers.flightDetailsList ){
   item.totaltaxes=0
   item.currentValue=JSON.parse(JSON.stringify(item))
    item.classes=JSON.parse(JSON.stringify(item.PassengerDetail))

    item.classes.forEach((clas:any)=>{
      clas.currentValue=JSON.parse(JSON.stringify(clas))
      if('passengerBookingClasses' in clas.fareDetails){
        console.log('sadfaf',clas?.fareDetails?.passengerBookingClasses)
      clas?.fareDetails?.passengerBookingClasses.forEach((fareDetails:any)=>{
      fareDetails.currentValue=JSON.parse(JSON.stringify(fareDetails))
        fareDetails.fareDetailsPerPassengerType.taxes=this.objectToArray(fareDetails.fareDetailsPerPassengerType.taxes)
        for(let items of fareDetails.fareDetailsPerPassengerType.taxes ){
          this.updateTaxValue(items,fareDetails)
    
        }
        currentTotal+=Number(fareDetails.fareDetailsPerPassengerType?.finalTax?(fareDetails?.fareDetailsPerPassengerType?.finalTax):0)+Number(fareDetails.fareDetailsPerPassengerType?.baseFare?(fareDetails?.fareDetailsPerPassengerType?.baseFare):0)

      })}
    })






    
  }}
amendAirItinerariesItem.currentTotalVaue=currentTotal||0
  this.ChangeRescheduleTotalTax()
   

}


ChangeRescheduleTotalTax(){
  
  for(let ite of this.amendAirItineraries){
    ite.TotalRescheduleAmount=0
  ite.totalRescheduleAmount=0
  for(let Passengers of ite?.PassengerDetail||[]){
  const baseFare = Passengers?.rescheduleComponent?.baseFareCharges ?? 0;
  const airlineTaxes = Passengers?.rescheduleComponent?.airlineTaxes ?? 0;
  ite.totalRescheduleAmount += baseFare + airlineTaxes;
  for(let item of Passengers.flightDetailsList ){
    // item.totaltaxes=0
    //  item.classes={...item.bookingClasses[0]}
      // item.classes.fareDetailsPerPassengerType.taxes=this.arrayToObject(item.classes.fareDetailsPerPassengerType.taxes)

    //  item.classes.fareDetailsPerPassengerType.taxes=this.objectToArray(item.classes.fareDetailsPerPassengerType.taxes)
    item.classes.forEach((clas:any)=>{
     let total=0
     if('passengerBookingClasses' in clas.fareDetails){
      clas.fareDetails.passengerBookingClasses.forEach((fareDetails:any)=>{
        fareDetails.totaltaxes=0
        for(let items of fareDetails.fareDetailsPerPassengerType.taxes ){
          this.updateTotalTaxValue(items,fareDetails)
    
        }
        ite.TotalRescheduleAmount+=fareDetails.totaltaxes+Number(fareDetails.fareDetailsPerPassengerType.baseFare?(fareDetails.fareDetailsPerPassengerType.baseFare):0)
      })}
    })
    // for(let items of item.classes.fareDetailsPerPassengerType.taxes ){
    //    this.updateTotalTaxValue(items,item)
 
    //  }

   }

  }

if(this.viewEdit){
   ite.TotalRescheduleAmount=ite.totalRescheduleAmount

}else{
   ite.TotalRescheduleAmount=Number(ite.TotalRescheduleAmount)-Number(ite.currentTotalVaue)

}
}


}







amendmentRescheduledProcess(){
  let passenger:any=[]
  //  for(let ite of this.amendAirItineraries){

  // for(let PassengerDetailItem of ite.PassengerDetail){
  //   PassengerDetailItem.rescheduleComponent={
  //     otherCharges:0.0,
  //     supplierAmendment:PassengerDetailItem.feeRules,
  //     baseFareCharges:PassengerDetailItem?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.baseFare||0,
  //     airlineTaxes:PassengerDetailItem?.fareDetails?.passengerBookingClasses[0]?.fareDetailsPerPassengerType?.finalTax||0,
  //     rescheduledFees:PassengerDetailItem.feeMarkup
  //     }
    
    
  //   }
  
  //  }
  const hasMissingpnr = this.amendAirItineraries.some((itinerary: any) =>
  itinerary.PassengerDetail?.some((p: any) => !p.pnr)
);
if(!hasMissingpnr){

 if(this.amendSource==='GALELIO'){
  
  const hasMissingTicket = this.amendAirItineraries.some((itinerary: any) =>
  itinerary.PassengerDetail?.some((p: any) => !p.ticketNumber)
);
if(!hasMissingTicket){

  let passengerData:any={
    list: this.PassengerDetail
  }
  //  this.amendAirItineraries.rescheduleFlightData.passengerDetails= passengerData.list
   for(let amendAirItineraries of this.amendAirItineraries){
let passengerData:any={
    list: amendAirItineraries.PassengerDetail
  }
       amendAirItineraries.rescheduleFlightData.passengerDetails= passengerData.list
   for(let Passengers of amendAirItineraries.rescheduleFlightData.passengerDetails){
  Passengers.fareDetails={
    passengerBookingClasses:[]
  }

    for(let item of Passengers.flightDetailsList ){
      // item.totaltaxes=0
    // item.totaltaxes=0
    item.classes.forEach((clas:any)=>{
      // passenger.push(clas)

       clas.fareDetails.passengerBookingClasses.forEach((fareDetails:any)=>{
        // fareDetails.fareDetailsPerPassengerType.finalTax=0
        if(fareDetails.fareDetailsPerPassengerType.taxes&&fareDetails.fareDetailsPerPassengerType.taxes?.length>0){
// console.log(fareDetails.fareDetailsPerPassengerType.taxes)
        
         this.updateTaxtempValue(fareDetails.fareDetailsPerPassengerType.taxes,fareDetails)
         fareDetails.fareDetailsPerPassengerType.taxes=this.arrayToObject(fareDetails.fareDetailsPerPassengerType.taxes)
        //  console.log(fareDetails.fareDetailsPerPassengerType.taxes)

        fareDetails.fareDetailsPerPassengerType.finalTax= fareDetails?.totaltaxes   
         }else{
          fareDetails.fareDetailsPerPassengerType.taxes={}
         }
       
       })
     })
    
  Passengers.fareDetails.passengerBookingClasses?.push(...item?.classes[0]?.fareDetails?.passengerBookingClasses)

   }
  
    //  Passengers.bookingClasses=[...item.classes]
   }
   amendAirItineraries.rescheduleFlightData.fare=[amendAirItineraries.rescheduleFlightData.fare]
   amendAirItineraries.rescheduleFlightData.routeRequest=amendAirItineraries.flightDetails.routeRequest

  }

  this.disabled=true


//  let request:any={
//   itineraryId:this.amendAirItineraries?.uuid,
//    amendmentId:this.AmendProcessDetail?.uuId,
//   userBookingRequest:this.amendAirItineraries.rescheduleFlightData,
 
//   "rescheduledCharges": {
//     "rescheduledFees": this.PassengerDetail.feeMarkup,
//     "otherCharges": 0.0,
//     "supplierAmdFees":this.PassengerDetail.feeRules 
// }
     
//  }

let req:any={"airItineraryLists":this.amendAirItineraries.map((item:any)=>{
return {
  "itineraryUuid": item?.uuid,
  "cabinClass":item?.cabinClass,
      "amendmentId": this.AmendProcessDetail?.uuId,
      "ordersPassengersDetailsList": item?.PassengerDetail.map((PassengerDetails:any)=>{
        const fareInfo = PassengerDetails?.fareDetails;
const fareDetails = fareInfo
  ? {
    passengerBookingClasses:fareInfo?.passengerBookingClasses.map((fareDetail:any)=>{
    return { source: fareDetail.source,
      fareType: fareDetail.fareType,
      supplier: fareDetail.supplier,
      fareBasis: fareDetail.fareBasis,
      bookingClass: fareDetail.bookingClass,
      corporateFare: fareDetail.corporateFare,
          passengerType: fareDetail.fareDetailsPerPassengerType?.passengerType,

      fareTypeDisplay: fareDetail.fareTypeDisplay,
      seatsAvailability: fareDetail.seatsAvailability,
      baggageInfo: fareDetail.baggageInfo,
      
      
      otherData: fareDetail.otherData,
      fareDetailsPerPassengerType:{
        baseFare: fareDetail.fareDetailsPerPassengerType?.baseFare,
      finalTax: fareDetail.fareDetailsPerPassengerType?.finalTax,
      taxes:
        Array.isArray(fareDetail.fareDetailsPerPassengerType?.taxes) &&
        fareDetail.fareDetailsPerPassengerType?.taxes.length === 0
          ? {}
          : fareDetail.fareDetailsPerPassengerType?.taxes,
            passengerType: fareDetail.fareDetailsPerPassengerType?.passengerType,

      }
    }
    })
    }
  : null;
        return {
         "firstName": PassengerDetails?.firstName,
          "lastName": PassengerDetails?.lastName,
          "title": PassengerDetails?.title,
          "fareDetails": fareDetails,
          "ticketNumber": PassengerDetails?.ticketNumber,
            "pnr": PassengerDetails?.pnr,
          "passengerType": PassengerDetails?.passengerType,
          "amendmentCharges": {
            "supplierAmdFees": PassengerDetails?.feeRules,
            "otherCharges": 0,
            "cancellationFees": 0.0,
            "resellerCharges": 0.0,
            "rescheduledFees": PassengerDetails?.feeMarkup
          },
           "flightDetailsList":PassengerDetails?.flightDetailsList.map((flightlist:any)=>{
            const arrival = new Date(flightlist?.schArrivalTime);
const departure = new Date(flightlist?.schDepartureTime);

const travelDuration = Math.floor((arrival.getTime() - departure.getTime()) / (1000 * 60)); // in minutes

            return {
    "layOver": flightlist?.layOver,
    "toAirport": flightlist?.toAirport,
    "toTerminal":flightlist?.toTerminal,
    "carrierName": flightlist?.carrierName,
    "fromAirport": flightlist?.fromAirport,
    "flightNumber":flightlist?.flightNumber,
    "fromTerminal": flightlist?.fromTerminal,
    "equipmentType": flightlist?.equipmentType,
    "bookingClasses": flightlist?.bookingClasses ,
    "schArrivalTime": flightlist?.schArrivalTime,
    "travelDuration": travelDuration,
    "schDepartureTime": flightlist?.schDepartureTime,
  
    // "totaltaxes": 0,
}
          })
        }
      }),
      "rescheduledCharges": {
        "supplierAmdFees": item?.PassengerDetail?.feeRules,
        "otherCharges": 0.0,
        "cancellationFees": 0.0,
        "resellerCharges": 0.0,
        "rescheduledFees":  item?.PassengerDetail?.feeMarkup
      }
}
})
}

let request:any=req
this.CartService
.AmendRescheduleV2Data(request,this.cartUuid)
.subscribe({
  next : (res:any) => {
    this.disabled=false
    if(res) {
      

      this.getOrder(this.cartUuid)
      this.GetAmend(this.cartUuid)

      this.showAmendProcess=false
      this.showAmendRescheduleProcess=false
          this.showActionTabs=false

      this.toastMsgService.setMsg({msg : 'Success',msgTitle : "Success", msgType : "I"});

    } else {
    
    } 
  },error : (err) => {
    this.toastMsgService.setMsg({msg : 'Failed to Amend',msgTitle : "Warning", msgType : "W"});

    this.disabled=false


  }
}
)}else{
  this.disabled=false
  // this.getOrder(this.cartUuid)

  console.log('jkjkjj')
  this.toastMsgService.setMsg({msg : 'Ticket Number is missing field',msgTitle : "Warning", msgType : "W"});

}
 }
 else{
  
  //  this.amendAirItineraries.rescheduleFlightData.passengerDetails= passengerData.list
   for(let amendAirItineraries of this.amendAirItineraries){
    let passengerData:any={
    list: amendAirItineraries.PassengerDetail
  }
   amendAirItineraries.rescheduleFlightData.passengerDetails= passengerData.list

   for(let Passengers of amendAirItineraries.rescheduleFlightData.passengerDetails){
  Passengers.fareDetails={
    passengerBookingClasses:[]
  }

    for(let item of Passengers.flightDetailsList ){
      // item.totaltaxes=0
    // item.totaltaxes=0
    item.classes.forEach((clas:any)=>{
      // passenger.push(clas)

       clas.fareDetails.passengerBookingClasses.forEach((fareDetails:any)=>{
        // fareDetails.fareDetailsPerPassengerType.finalTax=0
        if(fareDetails.fareDetailsPerPassengerType.taxes&&fareDetails.fareDetailsPerPassengerType.taxes?.length>0){
// console.log(fareDetails.fareDetailsPerPassengerType.taxes)
        
         this.updateTaxtempValue(fareDetails.fareDetailsPerPassengerType.taxes,fareDetails)
         fareDetails.fareDetailsPerPassengerType.taxes=this.arrayToObject(fareDetails.fareDetailsPerPassengerType.taxes)
        //  console.log(fareDetails.fareDetailsPerPassengerType.taxes)

        fareDetails.fareDetailsPerPassengerType.finalTax= fareDetails?.totaltaxes   
         }else{
          fareDetails.fareDetailsPerPassengerType.taxes={}
         }
       
       })
     })
    
  Passengers.fareDetails.passengerBookingClasses?.push(...item?.classes[0]?.fareDetails?.passengerBookingClasses)

   }
  
    //  Passengers.bookingClasses=[...item.classes]
   }
  amendAirItineraries.rescheduleFlightData.fare=[amendAirItineraries.rescheduleFlightData.fare]
amendAirItineraries.rescheduleFlightData.routeRequest=amendAirItineraries.flightDetails.routeRequest

  }

  this.disabled=true


//  let request:any={
//   itineraryId:this.amendAirItineraries?.uuid,
//    amendmentId:this.AmendProcessDetail?.uuId,
//   userBookingRequest:this.amendAirItineraries.rescheduleFlightData,
   
//   "rescheduledCharges": {
//     "rescheduledFees": this.PassengerDetail.feeMarkup,
//     "otherCharges": 0.0,
//     "supplierAmdFees":this.PassengerDetail.feeRules 
// }
    

  
//  }

let req:any={"airItineraryLists":this.amendAirItineraries.map((item:any)=>{
return {
  "itineraryUuid": item?.uuid,
  "cabinClass":item?.cabinClass,
      "amendmentId": this.AmendProcessDetail?.uuId,
      "ordersPassengersDetailsList": item?.PassengerDetail.map((PassengerDetails:any)=>{
         const fareInfo = PassengerDetails?.fareDetails;
const fareDetails = fareInfo
  ? {
    passengerBookingClasses:fareInfo?.passengerBookingClasses.map((fareDetail:any)=>{
    return { source: fareDetail.source,
      fareType: fareDetail.fareType,
      supplier: fareDetail.supplier,
      fareBasis: fareDetail.fareBasis,
      bookingClass: fareDetail.bookingClass,
      corporateFare: fareDetail.corporateFare,
          passengerType: fareDetail.fareDetailsPerPassengerType?.passengerType,

      fareTypeDisplay: fareDetail.fareTypeDisplay,
      seatsAvailability: fareDetail.seatsAvailability,
      baggageInfo: fareDetail.baggageInfo,
      
      
      otherData: fareDetail.otherData,
      fareDetailsPerPassengerType:{
        baseFare: fareDetail.fareDetailsPerPassengerType?.baseFare,
      finalTax: fareDetail.fareDetailsPerPassengerType?.finalTax,
      taxes:
        Array.isArray(fareDetail.fareDetailsPerPassengerType?.taxes) &&
        fareDetail.fareDetailsPerPassengerType?.taxes.length === 0
          ? {}
          : fareDetail.fareDetailsPerPassengerType?.taxes,
            passengerType: fareDetail.fareDetailsPerPassengerType?.passengerType,

      }
    }
    })
    }
  : null;
        return {
         "firstName": PassengerDetails?.firstName,
          "lastName": PassengerDetails?.lastName,
          "title": PassengerDetails?.title,
          "fareDetails": fareDetails,
          "ticketNumber": PassengerDetails?.ticketNumber,
          "pnr": PassengerDetails?.pnr,
          "passengerType": PassengerDetails?.passengerType,
          "amendmentCharges": {
            "supplierAmdFees": PassengerDetails?.feeRules,
            "otherCharges": 0,
            "cancellationFees": 0.0,
            "resellerCharges": 0.0,
            "rescheduledFees": PassengerDetails?.feeMarkup
          },
          "flightDetailsList":PassengerDetails?.flightDetailsList.map((flightlist:any)=>{
            const arrival = new Date(flightlist?.schArrivalTime);
const departure = new Date(flightlist?.schDepartureTime);

const travelDuration = Math.floor((arrival.getTime() - departure.getTime()) / (1000 * 60)); // in minutes

            return {
    "layOver": flightlist?.layOver,
    "toAirport": flightlist?.toAirport,
    "toTerminal":flightlist?.toTerminal,
    "carrierName": flightlist?.carrierName,
    "fromAirport": flightlist?.fromAirport,
    "flightNumber":flightlist?.flightNumber,
    "fromTerminal": flightlist?.fromTerminal,
    "equipmentType": flightlist?.equipmentType,
    "bookingClasses": flightlist?.bookingClasses ,
    "schArrivalTime": flightlist?.schArrivalTime,
    "travelDuration": travelDuration,
    "schDepartureTime": flightlist?.schDepartureTime,
  
    // "totaltaxes": 0,
}
          })
        }
      }),
      "rescheduledCharges": {
        "supplierAmdFees": item?.PassengerDetail?.feeRules,
        "otherCharges": 0.0,
        "cancellationFees": 0.0,
        "resellerCharges": 0.0,
        "rescheduledFees":  item?.PassengerDetail?.feeMarkup
      }
}
})
}

let request:any=req
console.log(request)
  this.CartService
  .AmendRescheduleV2Data(request,this.cartUuid)
  .subscribe({
    next : (res:any) => {
      this.disabled=false
      if(res) {
        

        this.getOrder(this.cartUuid)
        this.GetAmend(this.cartUuid)

        this.showAmendProcess=false
        this.showAmendRescheduleProcess=false
        this.toastMsgService.setMsg({msg : 'Success',msgTitle : "Success", msgType : "I"});
    this.showActionTabs=false

      } else {
      
      } 
    },error : (err) => {
      this.toastMsgService.setMsg({msg : 'Failed to Amend',msgTitle : "Warning", msgType : "W"});

      this.disabled=false


    }
  }
)
}
}
else{
    this.disabled=false
  // this.getOrder(this.cartUuid)

  // console.log('jkjkjj')
  this.toastMsgService.setMsg({msg : 'PNR is missing field',msgTitle : "Warning", msgType : "W"});

}
}
onCabinChange( value: any) {
  // If first item is selected, auto-fill second

    for (let i = 0; i < this.amendAirItineraries.length; i++) {
      this.amendAirItineraries[i].cabinClass = value;   // copies the same value to all others
      // OR you can use a fixed value for others, e.g.:
      // this.data[i].cabinClass = 'Y';
    }
  }
  safeParse(json: any) {
  try {
    return JSON.parse(json);
  } catch {
    return json; // return as-is if already object or invalid
  }}
}
